import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint sonarjs/no-duplicate-string: 0 */


import { extendTheme } from "native-base";
import baseTheme from "./base.theme";
import Platform from "react-native-web/dist/cjs/exports/Platform"; // Define the config

var config = {
  colors: {
    primary: {
      100: "#73994A",
      200: "#73994A",
      300: "#DF4505",
      // TODO: replace this placeholder with appropriate color (this is for the focusring and hover to work)
      400: "#73994A",
      500: "#73994A",
      600: "#73994A"
    },
    secondary: {
      100: "#D7BA8A",
      200: "#D38232",
      300: "#73994A"
    },
    background: {
      100: "#F9F7F0",
      200: "#EBE9E9",
      300: "#DAD4D5",
      400: "#F9F7F0"
    },
    indicatorBannerColors: {
      indicatorBannerColor_NI: "#C6653B",
      indicatorBannerColor_LT: "#a8b341",
      indicatorBannerColor_CSK_B: "#b3292d",
      indicatorBannerColor_Default: "#C6653B"
    },
    outletLocationRestText: "#73994A",
    orderOnlineHomeButton: "#73994A",
    errorModalHeaderBg: "#F9F7F0",
    circularAddBtn: "#73994A",
    locationListBtn: "#73994A",
    startBgColor: "#F9F7F0",
    secondary200Mobile: "#73994A",
    confirmationModalOptionBg: "#F9F7F0",
    asapOptionBg: "#F9F7F0",
    asapTextColor: "#989182",
    emptyCartHeaderBgColor: "#F2EFEA",
    menuItemCardBg: "#F9F7F0",
    menuButtonBackgroundColor: "#73994A",
    orderSettingsTextColor: "#73994A",
    categoriesText: "#73994A",
    modalCategoriesText: "#73994A",
    inActiveCategoriesText: "#989182",
    inActiveModalCategoriesText: "#606060",
    menuItemAddButtonColor: "#73994A",
    menuDetailsMobileHeaderText: "#73994A",
    menuItemNameColor: "#73994A",
    cartHeaderOrderType: "#282C25",
    cartHeaderLocationName: "#73994A",
    configOptionsAccordionBackground: "#72994C",
    hStackArrowsColor: "#72994C",
    menuDetailsModifiersBorderColor: "#73994A",
    menuDetailsBackToMenu: "#73994A",
    infoLinkColor: "#73994A",
    legalDisclaimerText: "#70695c",
    headerBackground: "white",
    headerBackgroundTop: "white",
    sliderItemColor: "#72994C",
    btnHoverColor: "#5A783A",
    timeDropDownBg: "#FFFFFF",
    reservationsCardBg: "#fff",
    modalLightBg: "#FFFFFF",
    modalDarkBg: "#FFFFFF",
    itemAddToCartPopupBackground: "#73994A",
    confirmPickupDetailsText: "#72994C",
    defaultMenuTextColor: "#020001",
    orderConfirmationTextColor: "#72994C",
    previousOrderItemStatus: "#73994A",
    defaultMenuBannerBg: "#F9F7F0",
    selectedOptionBorderColor: "#73994A",
    scrollToTopColor: "#73994A",
    menuItemCardBorder: "transparent",
    menuItemPriceColor: "#73994A",
    menuItemCalorieColor: "#73994A",
    refreshIconColor: "#73994A",
    accordionDescription: "white",
    searchResultsName: "#303030",
    tempSilderText: "#BA685C",
    selectTemperatureAccordian: "transparent",
    categoryNavBgColor: "#F9F7F0",
    plusIconColor: "#73994A",
    specialInstArrowColor: "black",
    itemIsFor: "#606060",
    downArrowColor: "#020001",
    mobileBg: "#FFFFFF",
    itemIsForName: "#282C25",
    cartPhoneNumber: "#73994A",
    cartItemActionBtn: "#73994A",
    cartItemPrice: "#73994A",
    cartNoOfItemsText: "#B31900",
    selectedMenuCategoryBorder: "#73994A",
    orderSettingsDesktop: "#989182",
    orderSettingsMobile: "#989182",
    cartItemTitle: "#989182",
    specialInstructions: "#282C25",
    cartItemOption: "#989182",
    menuDetailsSliderItemBackground: "#F9F7F0",
    menuDetailItemNameColor: "#70695c",
    menuDetailsItemPriceColor: "#70695c",
    ninjaIconColor: "#73994A",
    menuDetailsItemDescriptionColor: "#282C25",
    menuDetailsItemCaloriesCaolor: "#73994a",
    menuDetailsSliderHoverColor: "#73994A",
    loginModalTextColor: "#73994A",
    hStackArrowsBg: "#FDFDFDD9",
    requiredTextColor: "#73994A",
    menuDetailAccordionTextColor: "#989182",
    menuDetailModifyOrRemoveColor: "#464838",
    locationConfirmationHeadings: "#73994A",
    locationListingItemHeading: "#989182",
    locationListingItemHeadingMobile: "#73994A",
    locationListingItemText: "#989182",
    reorderInfoTextColor: "#282C25",
    menuDetailAccordionDownArrowColor: "#73994A",
    recommendationaInfoTextColor: "#282C25",
    reOrderAddBtnBorder: "#73994A",
    recommendationHeadingColor: "#020001",
    sliderWithButtonsBackground: "#FFFFFFE5",
    orderSettingsDateTimeChoiceColor: "#2D2926",
    themeDisableButton: "#E5E5E5",
    orderConfirmationDivider: "#E5E5E5",
    menuDetailsAccordionDetailsBackground: "#F4F4F3",
    menuDetailsAccordionDetailsBackgroundNotDefaultExpanded: "#F4F4F3",
    locationsNear: "#2A2C25",
    categoryBoxDivider: "#D6D6D6",
    firstCategoryBoxDivider: "#D6D6D6",
    remoteCheckinWaitTimeHeaderText: "rgba(115, 153, 74, 1)",
    remoteCheckinWaitTimeText: "rgba(115, 153, 74, 1)",
    remoteCheckinWaitTime: "rgba(96, 96, 96, 1)",
    remoteCheckinRefreshBtnColor: "#73994A",
    remoteCheckinRefreshBtnBg: "#FFFFFF",
    categoryBoxTop: "#D6D6D6",
    categoryBoxBottom: "#D6D6D6",
    quantityArrowColor: "#73994A",
    textCTAColor: "#73994A",
    orderSettingsDivider: "#D6D6D6",
    orderSettingsDividerMobile: "#D6D6D6",
    orderSettingsBorder: "#D6D6D6",
    modalTextColor: "#020001",
    selectedCarouselItemWithoutImage: "#F9F7F0",
    unselectedCarouselItemWithoutImage: "#ffff",
    checkoutButtonBackgroundColor: "#73994A",
    selectedListItem: "#F9F7F0",
    // NEED
    menuListTooltipBg: "#73994A",
    menuListTooltipColor: "#FFFFFF",
    menuDetailTooltipBg: "#54301A",
    menuDetailTooltipColor: "#FFFFFF",
    themeErrorTextColor: "#AF272F",
    themeErrorColor: "#C03838",
    youMightLikeBannerColor: "#73994A",
    newIndicatorBannerColor: "#C6653B",
    skuUnavaliableTextColor: "#A2402A",
    menuDetailTemparatureSliderLabelColor: "#303030",
    globalBannerBg: "#f9f7f0",
    deliveryModalHeadingColor: "#2A2C25",
    deliveryModalBrandColor: "#54301A",
    bannerDropShadow: "#5F2C2D",
    deliveryModalNameColor: "#A2402A",
    addressTextColor: "#989182",
    notSelectedOptionBorderColor: "#D7D7D7",
    // OLD COLORS
    themeTextFieldBoundary: "#DEDEDE",
    themeSectionSeparator: "#D6D6D6",
    themeSectionSeparatorDark: "#979797",
    listItemDivider: "#D6D6D6",
    cartNumberText: "#ffff",
    themeSectionTextDark: "#8A8A8A",
    backLinkColor: "#73994A",
    themeTextColor: "#989182",
    legalDesclaimerText: "#989182",
    themeGrey: "#606060",
    popoverBg: "#F2EFEA",
    separatorLineColor: "#2A2C25",
    categoryHeaderSeparator: "#EAEAEA",
    legalTextContainerBg: "#EFEFEF",
    menuLinksColor: "#989182",
    themeDarkGrey: "#2E2A26",
    orderInfoBg: "#ffff",
    specialInstInputBg: "#ffff",
    locationListItemBorder: "transparent",
    allLocationsSelectBgMobile: "#F9F7F0",
    allLocationsSelectBgDesktop: "#ffffff",
    locationCardBg: "#ffff",
    locationDropdownBg: "#ffff",
    allLocationsSelectBorderColorMobile: "#DEDEDE",
    allLocationsSelectBorderColorDesktop: "#DEDEDE",
    allLocationsItemBoxBorderColor: "#DEDEDE",
    allLocationsBodyBgMobile: "#ffffff",
    allLocationsBodyBgDesktop: "#F9F7F0",
    allLocationsSelectBorderColor: "#D6D6D6",
    confirmPickupDetailsChangeBtnBorder: "#73994A",
    // order tracking page
    orderStatusText: "#4D2C42",
    orderStatusCircleBg: "#4D2C42",
    locaionAndTimeHeaderBg: "#F9F7F0",
    locaionAndTimeHeaderBorder: "#DCDCDC",
    borderColorCallSection: "#DCDCDC",
    payNowButtonBg: "#73994A",
    curbsideCheckInPrimary: "#FFFFFF",
    curbsideCheckInSecondary: "#73994A",
    orderStatusSectionBg: "#F4F4F4",
    refreshButtonColor: "#73994A",
    checkText: "#303030",
    curbsideCheckInAvailable: "#7C7C7C",
    refreshButtonBg: "#FFFFFF",
    orderStatusSectionBorderColor: "#F4F4F4",
    // order tracking page end
    // NOT USED
    nutritionalHTMLColor: "#020001",
    reorderHeadingsText: "#020001",
    checkoutBorderColor: "transparent",
    categoriesHeadingColor: "#73994a",
    itemUnavailableCardBg: "#F9F7F0",
    itemCardBg: "#F9F7F0",
    itemCardBgLight: "#F9F7F0",
    orderConfirmationCustomerEmail: "#494949",
    // ORDER CONFIRMATION START
    orderConfirmationBackground: "#F6F6F6",
    confirmationPrimary: "#73994A",
    confirmationSecondary: "#303030",
    confirmationAccent: "#2A2C25",
    confirmationAccentLight: "#666666",
    confirmationAccentDark: "#303030",
    confirmationCheckbox: "#73994A",
    confirmationThemeDark: "#000000",
    confirmationThemeLight: "#EEEEEE",
    confirmationThemeGrey: "#B0B0B0",
    podBackground: "white",
    confirmationSpecialInstructionsBg: "#EEEEEE",
    // ORDER CONFIRMATION END
    categoriesPopupInactive: "#606060",
    categoriesPopupBg: "white",
    bodyBg: "transparent",
    quickAddModalBg: "white",
    cardColor: "#F9F7F0",
    menuInfoBackgroundMobile: "#FFFFFF",
    menuInfoBackgroundDesktop: "#F9F7F0",
    selectedSKUItem: "#F9F7F0",
    nonSelectedSkuItem: "white",
    configOptionBg: "white",
    nonSelectedListItem: "white",
    selectedListItemWithImage: "white",
    nonExpandedAccordionBackground: "#F9F7F0",
    selectedDescriptionText: "#020001",
    remoteCheckinWaitTimeBg: "#F9F7F0",
    remoteCheckinWaitTimeBorderTwo: "rgba(115,153, 74, 0.1)",
    remoteCheckinWaitTimeBorderOne: "rgba(115,153, 74, 0.2)",
    remoteCheckinWaitTimeInnerBorder: "rgba(115,153, 74, 1)",
    remoteCheckinWaitTimeCircleBg: "#FFFFFF",
    remoteCheckinPartySizeText: "#282C25",
    carouselBorderColor: "#D6D6D6",
    signInTextColor: "#989182",
    registerTextColor: "#989182",
    recommendationsHeadingColor: "#989182",
    capacityInfoText: "#989182",
    selectedStateColor: "#2A2C25",
    pickupDateTimeText: "#989182",
    quantityColor: "#000000",
    timeDropdownColor: "#989182",
    searchKeywordHighlightColor: "#73994A",
    waitlistBannerBg: "#73994A",
    waitlistTableHeaderBg: "#F8F8F8",
    selectedWaitlistRow: "#F9F7F0",
    waitlistFooterBorderTop: "#B0B0B0",
    waitlistBottomBackground: "#F9F7F0",
    waitlistDisclaimer: "#282C25",
    //Menu search
    searchModalCategoryListBg: "#F6F6F6",
    searchIconContainerBgColor: "#DF4505",
    mobilePayUserLoginBackground: "#FFFFFF",
    mobilePayUserLoginButtonTextColor: "#FFFFFF",
    mobilePayBodyTextColor: "#606060",
    // new
    profileHeaderBackground: "#73994A",
    locationTopTabColor: "#73994A",
    grey300: "#303030",
    reoderInfoTextColor: "#404040",
    mobilePayNotYourCheckTextColor: "#606060",
    mobilePayReachOutSubTextColor: "#782434",
    onboardingButtonTextColor: "#FFFFFF",
    mobileAppAuthBg: "white",
    myReservationsBoxBg: "white",
    mobileAuthOrDividerBorderColor: "#CDCFD5",
    mobileAuthOrTextColor: "#737373",
    mobileAuthFooterPassiveText: "#808080",
    mobileAuthFooterActiveText: "#73994A",
    mobileAuthTransparentBg: "rgba(0, 0, 0, 0.7)",
    mobileCriticalModeHeding: "#606060",
    mobileCriticalModeText: "#959595",
    mobileCreateAccountDetailsSectionBackgroundColor: "#FFFFFF",
    mobileCreateAccountButtonTextColor: "#FFFFFF",
    mobileCreateAccountLegalNoticesColor: "#cb7034",
    mobileCriticalModeBg: "#E5E5E5",
    mobileForgotPasswordHeding: "#606060",
    linearGradientTransparent: "rgba(255,255,255,0)",
    linearGradientWhite: " rgba(255,255,255,1)",
    linearGradientCardDarkShade: "rgba(54, 26, 5, 0.84)",
    linearGradientCardLightShade: "rgba(54, 26, 5, 0.44)",
    linearGradientCardTransparent: "rgba(35,34,30,0)",
    linearGradientHeaderDark: "rgba(68, 59, 53, 0.5)",
    linearGradientHeaderLight: "rgba(105, 86, 76, 0.2)",
    ratingCardTitle: "#2A2C25",
    ratingCardSubheaderText: "#606060",
    ratingCardBodyHeader: "#606060",
    ratingCardTextAreaBorderColor: "F3F4EA",
    ratingCardTextAreaWordCount: "rgba(0, 0, 0, 0.4)",
    ratingCardSubmitButton: "#A2402A",
    ratingCardSubmitButtonText: "#FFFFFF",
    ratingCardDismissButtonText: "#808080",
    mobileForgotPasswordHeading: "#606060",
    mobileResetPasswordText: "#606060",
    mobileCustomBrandModalBg: "#F8F7F6",
    restaurantDetailsDataText: "#303030",
    mobileHeaderBg: "rgba(255, 255, 255, 0.9)",
    routerNavigationHeaderColor: "rgba(0, 0, 0, 0.7)",
    displayImageFallbackBackground: "#C6C6C6",
    mobileOrderDetailsBanner: "#F5F7E8",
    mobileOrderDetailsDisabledButton: "#C6C6C6",
    mobileOrderDetailsBg: "white",
    locationModalHeadingColor: "#2A2C25",
    locationModalBodyDataColor: "#808080",
    locationModalDividerColor: "#C6C6C6",
    restaurantsTimingDetails: "#606060",
    restaurantLabelColor: "#606060",
    joinWaitlistColor: "#B31900",
    disableJoinWaitlistColor: "#C6C6C6",
    waitlistHeaderAddressHeaderBorder: "#D6D6D6",
    mobileSelectedVehicleTypeBg: "#F4F4F4",
    mobileSliderSeparator: "#BEBEBE",
    locationInfographicModalTextColor: "#606060",
    locationInfographicModalActionButtonTextColor: "#FFFFFF",
    inputPlaceholderTextColor: "#303030",
    restaurantInfoNumberAndDistanceTextColor: "#73994A",
    restaurantDetailsHeaderBackground: "#FFFFFF",
    amenitiesHeadingColor: "#73994A",
    amenitiesDividerColor: "rgba(0,0,0,0.2)",
    amenitiesActionButtonsColor: "#73994A",
    currentStatusAndWaitlistDividerColor: "rgba(0,0,0,0.1)",
    restaurantWaitlistTextColor: "#606060",
    joinWaitlistButtonColor: "#B31900",
    orderFromHereButtonTextColor: "#FFFFFF",
    restaurantAboutSectionHeadingTextColor: "#73994A",
    restaurantAboutSectionBodyTextColor: "#303030",
    restaurantImageBorderColor: "#FFFFFF",
    restaurantNumberAndDistanceDividerColor: "rgba(0,0,0,0.20)",
    restaurantHoursTextColor: "#73994A",
    waitlistRestaurantInfoBoxText: "#54301A",
    restaurantSpecialDayHeadingTextColor: "#303030",
    restaurantSpecialDayBodyTextColor: "#606060",
    restaurantTimingsHeadingTextColor: "#73994A",
    restaurantTimingsDividerColor: "rgba(0,0,0,0.1)",
    restaurantDetailsSeparatorDividerColor: "rgba(0,0,0,0.1)",
    restaurantTimingsTextColor: "#303030",
    locationTabNavigationNotFocusedTabText: "#606060",
    locationInfographicLoginBackgroundColor: "#FFFFFF",
    locationOverlayMyLocationsTitles: "#303030",
    locationOverlayMyLocationsScrollView: "#FFFFFF",
    locationOverlaySelectLocationColor: "#2A2C25",
    noRecentLocationsTextColor: "#606060",
    searchThisAreaText: "#FFFFFF",
    selectedWeekDayColor: "#223E6A",
    notSelectedWeekDayColor: "#FFFFFF",
    weekDayBorderColor: "#DCDCDC",
    currentWeekDayIndicator: "#49909B",
    mobileScrollableMenuTab: "#F8F8F8",
    orderConfirmationThanksSubHeaderColor: "#505050",
    pickupRestaurantTitle: "#737373",
    pickupRestaurantName: "#303030",
    pickupRestaurantAddress: "#606060",
    pickMyOrderCardTitle: "#303030",
    pickUpMyOrderHStackText: "#303030",
    bottomSheetTitleColor: "#303030",
    errorModalBackgroundColor: "rgba(29, 26, 26, 0.88)",
    errorModalTitleColor: "#2A2C25",
    errorModalSubTitleTextColor: "#606060",
    errorModalOKButtonTextColor: "#FFFFFF",
    addCardModalValidWarningTextColor: "#D30000",
    cardExpiredColor: "#D51010",
    saveCardCheckbox: "#737373",
    saveCardAddButtonTextColor: "#FFFFFF",
    enterCVVSubTitle: "#606060",
    enterCVVPlaceholderText: "#606060",
    enterCVVTooltipBgColor: "#e3e3e3",
    enterCVVValidWarningTextColor: "#D30000",
    enterCVVConfirmButtonDisabledColor: "#C6C6C6",
    enterCVVConfirmButtonTextColor: "#FFFFFF",
    mobilePaymentMethodIconBg: "#F6F6F6",
    mobilePaymentsCardTextColor: "white",
    mobileGiftCardGradientFirst: "rgba(115, 153, 74, 0.55)",
    mobileGiftCardGradientSecond: "#73994A",
    mobileMasterCardGradientFirst: "#2A0000",
    mobileMasterCardGradientSecond: "#912F2F",
    mobileMasterCardGradientThird: "#5A1F21",
    mobileVisaGradientFirst: "#026C6C",
    mobileVisaGradientSecond: "#12414B",
    mobileVisaGradientThird: "#015F5F",
    mobileDiscoverGradientFirst: "#95989F",
    mobileDiscoverGradientSecond: "#D1D5D8",
    mobileDiscoverGradientThird: "#93969B",
    mobileAmericanExpressGradientFirst: "#1B1B1D",
    mobileAmericanExpressGradientSecond: "#5E5E62",
    mobileAmericanExpressGradientThird: "#1E1E20",
    mobileJcbCardGradientFirst: "#001741",
    mobileJcbCardGradientSecond: "#195182",
    mobileJcbCardGradientThird: "#2B3E7F",
    mobilePaymentMethodAssistTextColor: "#808080",
    mobileCouponInputPlaceholderColor: "#C7C0C0",
    mobilePaymentsScreenBg: "white",
    addGiftCardBottomSheetBackdropColor: "rgba(29, 26, 26, 0.88)",
    enterCVVBottomSheetBackdropColor: "rgba(29, 26, 26, 0.88)",
    addCreditDebitCardTooltipBgColor: "#e3e3e3",
    yourOrderTitle: "#303030",
    orderDescriptionItem: "#2A2C25",
    orderTotalTitle: "#54301A",
    pickupDetailsTitle: "#303030",
    carSideStackTitle: "#606060",
    cardCreateAnAccountHeading: "#303030",
    takeSurveyText: "#606060",
    joinEClubTitle: "#303030",
    joinEClubTickScheme: "#A8AD00",
    mobileGiftVoucherGiftText: "#E7A227",
    mobileGiftVoucherVoucherIDText: "#C6C6C6",
    mobileGiftVoucherValueFirstGrad: "#F6C551",
    mobileGiftVoucherValueSecondGrad: "#B15801",
    mobileGiftVoucherBoxFirstGrad: "#423F3F",
    mobileGiftVoucherBoxSecondGrad: "#5F5852",
    mobileGiftCardNormalText: "white",
    wailistHomeScreenBannerGradientOne: "#BF7D3F",
    waitlistHomeScreenBannerGradientTwo: "#964631",
    waitlistHomeScreenBannerText: "#FFFFFF",
    waitlistBannerCircleOuterBorder: "rgba(255,255,255,0.2)",
    waitlistBannerFooterText: "#303030",
    waitlistPositionBackground: "#F3F4E7",
    waitlistPositionBorderTwo: "rgba(159, 167, 58, 0.1)",
    waitlistPositionBorderOne: "rgba(159, 167, 58, 0.2)",
    waitlistPositionInnerBorder: "#9FA73A",
    waitlistPositionCircleBackgroundColor: "#FFFFFF",
    waitlistPositionSubTitle: "#606060",
    waitlistPositionButtonBackground: "#FFFFFF",
    waitlistPositionSubTextColor: "#303030",
    waitlistSubCardsVerticalDivider: "#F6F6F6",
    waitlistDetailsSwiperText: "#FFFFFF",
    waitlistSwiperNavigationButtonBorderColor: "#FFFFFF",
    waitlistSwiperNavigationButtonBackgroundColor: "#FFFFFF",
    seasonFavouriteTitleText: "#FFFFFF",
    seasonFavouritesHeadingDivider: "#4D4D4D",
    waitlistMapSectionBorder: "#DCDCDC",
    waitlistMapSectionButtonBackground: "#FFFFFF",
    waitlistDetailsOrderbuttonText: "#FFFFFF",
    waitlistPositionHeadingText: "#2A2C25",
    waitlistDetailsScreenBackground: "#FFFFFF",
    waitlistBannerCircleBackgroundColor: "#FFFFFF",
    mobileCategoryNavigationBg: "#F8F8F8",
    mobileOrderSummaryBackground: "#F6F6F6",
    mobileOrderSummaryHeaderText: "#303030",
    mobileOrderSummaryDishQuantity: "#2A2C25",
    mobileOrderSummaryOtherInstructions: "#606060",
    mobileOrderSummaryOrderTotalDetailsItem: "#000000",
    mobileOrderSummaryOrderTotalDetailsItemCoupon: "#CA7C30",
    mobileOrderSummaryPaidByColor: "#303030",
    myAccountSubTextColor: "#606060",
    myAccountScreenBackroundColor: "#F6F6F6",
    myAccountScreenUserInfoTextColor: "#606060",
    myAccountCardShadow: "rgba(0, 0, 0, 0.2)",
    myAccountCardBackground: "#FFFFFF",
    ProfilePictureCircleBorderColor: "#FFFFFF",
    mobileOrderSettingsOptionStackBorderColor: "#DEDEDE",
    orderSettingsPickupDetails: "#2A2C25",
    orderSettingsBackdrop: "rgba(0, 0, 0, 0.7)",
    curbsideHomeScreenBannerGradientOne: "#BF7D3F",
    curbsideHomeScreenBannerGradientTwo: "#964631",
    curbsideHomeScreenBannerText: "#523020",
    curbsideDetailsBackground: "#F3F4E7",
    curbsidePickupScreenBackground: "#FFFFFF",
    curbsidePickupScreenDetailsBackground: "#F2F4E6",
    curbsidePickupScreenDetailsDivider: "#DCDCDC",
    curbsidePickupScreenBannerText: "#523020",
    curbsidePickupScreenDetailsSubText: "#303030",
    curbsidePickupScreenDetailsIconsBackground: "#F6F6F6",
    curbsidePickupScreenDetailsEditButtonText: "#993324",
    viewDirectionButtonTextColor: "#FFFFFF",
    restaurantLocationBottomSheetBackdropColor: "rgba(0,0,0,0.6)",
    modalHeaderBackgroundColor: "rgba(0, 0, 0, 0.7)",
    restuarantLocationBottomSheetLocationText: "#606060",
    addGiftCardHeaderTextColor: "#2A2C25",
    mobileOrderHistoryBackgroundColor: "#F6F6F6",
    mobileOrderHistoryItemCardHeaderBackgroundColor: "#F3F4E7",
    orderHistoryItemDividerColor: "#C6C6C6",
    orderHistoryReorder: "#73994A",
    orderHistoryDetailsText: "#303030",
    orderHistoryOrderFrom: "#808080",
    orderHistoryDetailsAddress: "#606060",
    jwcLeaveTheLineModalHeadBg: "#D7D2CB",
    orderHistoryDetailsBGColor: "#F6F6F6",
    searchBarBackground: "#FFFFFF",
    addCardFooterButtonText: "#FFFFFF",
    homeScreenBackgroundColor: "#F6F6F6",
    homeScreenOrderNowButtonTextColor: "#73994A",
    homeScreenHeaderIconColors: "#FFFFFF",
    homeScreenLoginBorderColor: "#ffffff",
    homeScreenCardButtonTextColor: "#FFFFFF",
    homeScreenCardButtonBorderColor: "#FFFFFF",
    homeScreenCardTextColor: "#FFFFFF",
    myAccountCartAmountTextBorderColor: "#FFFFFF",
    myAccountCartAmountTextColor: "#FFFFFF",
    selectPreferredLocationBackgroundColor: "#FFFFFF",
    outletLocationItemIconText: "#FFFFFF",
    outletLocationItemButtonText: "#FFFFFF",
    profileScreenMainModalBackgroundColor: "#FFFFFF",
    HomeScreenlinearGradientBackgroundColor: "#F6F6F6",
    homeScreenRecentOrdersListItemSubTextColor: "#606060",
    homeScreenRecentOrdersListItemDividerColor: "#C6C6C6",
    homeScreenRecentOrdersListItembackgroundColor: "#FFFFFF",
    homeScreenRecentOrdersListItemButtonTextColor: "#FFFFFF",
    addCardPlaceholderTextColor: "#606060",
    addCardCheckboxTextColor: "#606060",
    mobileReorderBg: "#F8F8F8",
    editProfileScreensBackgroundColor: "#FFFFFF",
    googleSocialSignInBGColor: "#FFFFFF",
    facebookSocialSignInBGColor: "#1877F2",
    appleSocialSignInBGColor: "#000000",
    socialAuthBorderColor: "#DEDEDE",
    createAccountPreferredLocationBGColor: "#F8F7F6",
    cartScreenBackgroundColor: "#FFFFFF",
    orderLimitReacherModalBackdrop: "rgba(0,0,0,0.7)",
    cartHeaderPressableColor: "#F6F6F6",
    securityQuestionContainer: "#ffffff",
    securityQuestionMenuColor: "#C6c6c6",
    securityQuestionTextColor: "#606060",
    createAccountBackgroundColor: "#FFFFFF",
    createAccountScreenTextColor: "#303030",
    createAccountZipCodeBorderColor: "#DCDCDC",
    createAccountZipCodeLabelColor: "#808080",
    settingScreenBg: "#F8F8F8",
    settingListItemShadow: "rgba(0,0,0,0.5)",
    frequentlyOrderedItemBackground: "#FFFFFF",
    frequentlyOrderedItemSubText: "#505050",
    giftCardBalanceColor: "#606060",
    mobileDividerColor: "rgba(0,0,0,0.5)",
    homescreenPromoBackdrop: "rgba(0, 0, 0, 0.6)",
    fullHomescreenPromoBg: "#F8F7F6",
    paymentScreenImportantTextDescription: "#808080",
    curbsideBannerTagColor: "#FFFFFF",
    guestFavoritesBackgroundColor: "#F6F6F6",
    guestFavouritePopOverBGColor: "#F3F4E7",
    guestPopoverBackdropColor: "rgba(0,0,0,0.7)",
    mobilePayBgColor: "#FFFFFF",
    mobilePayDividerColor: "#C6C6C6",
    mobilePayDividerTextColor: "#808080",
    mobilePayWorksHeaderTextColor: "#404040",
    mobilePayWorksListItemBgColor: "#F6F6F6",
    mobilePayWorksTitleColor: "#303030",
    mobilePayWorksItemTitleColor: "#2A2C25",
    mobilePayGuidlineBgColor: "#F6F6F6",
    mobilePayWhiteTextColor: "#FFFFFF",
    reorderTopTabScreenBackgroundColor: "#F6F6F6",
    errorPopUpContentDividerBackgroundColor: "#F6F6F6",
    menuSliderSelectedCountTextColor: "#808080",
    menuCustomisationButtonColor: "#A2402A",
    menuCustomisationIsSelectedMobileColor: "#F3F4EA",
    menuCustomisationIsSelectedBorderMobileColor: "#A8AD00",
    menuCustomisationNotSelectedBorderMobileColor: "#C6C6C6",
    joinWaitListMapTextColor: "#464838",
    joinWaitlistBackgroundColor: "#F6F6F6",
    selectedNumberOfGuestBorderColor: "#73994A",
    selectedNumberOfGuestBackgroundColor: "#F3F4EA",
    backgroundWhite: "#fff",
    menuCustomisationListIItemActiveColour: "#73994A",
    collapsableDropdownItemBgColor: "#F6F6F6",
    smartRecommendationBackgroundColor: "#E5E5E5",
    smartRecommendationActiveDotColor: "#54301A",
    smartRecommendationInActiveDotColor: "#C6C6C6",
    howMobilePayWorksModalBg: "rgba(0,0,0,0.6)",
    unavailableWaitlistColor: "#BDBDBD",
    mobileReorderScreenTitleColor: "#2A2C25",
    // ORDER CONFIRMATION START
    // ORDER CONFIRMATION END
    checkoutRadioButtonBorderColor: "#D6D6D6",
    pickupMethodBackgroundColor: "#F6F6F6",
    pickupMethodSectionDivider: "#DCDCDC",
    // Menu Search Start
    suggestedSearchTextColor: "#404040",
    noResultFoundMenuSearchBg: "#F6F6F6",
    searchModalBackgroundColor: "white",
    menuSearchModalDivider: "#ABABAB",
    searchCardCategorySlugColor: "grey",
    inputFieldBackgroundColor: "#F6F6F6",
    suggestionsBorderColor: "#C6C6C6",
    clearTextColor: "#993324",
    noResultTextColor: "#B31900",
    backgroundE5E5: "#E5E5E5",
    searchItemCardTextColor: "#505050",
    menuSearchBarContainerBg: "#FFFFFF",
    // Menu Search End
    ///Order Ahead Flow Tokens
    serveAsEntreeSwitch: "#97BC67",
    //mobile Payment Options tokens
    paymentOptionsHeaderColor: "#F6F7F0",
    paymentOptionsBorderColor: "#DCDCDC",
    //mobile app profile
    editProfileInfoLabelColor: "#808080",
    editProfileInfoAsteriskColor: "#73994A",
    profilePictureShadowColor: "#000000",
    mobileOrderInfoBannerBorderColor: "#D6D6D6",
    // order tracking page
    // order tracking page end
    //mobile restaurant details skeleton
    skeletonColorGrey: "#DCDCDC",
    onboardingScreenBGColor: "#FFFFFF",
    onboardingActiveDotColor: "#000000",
    onboardingInactiveDotColor: "rgba(0,0,0, 0.4)",
    onboardingButtonBackgroundColor: "#73994A",
    orderDetailsSkeletonBgColor: "#C4C4C4",
    //tab bar
    backgroundTabBarColor: "white",
    shadowColor: "#2c2c2c",
    //home-screen header avatar
    homeScreenHeaderAvatarBg: "lightgrey",
    //menu-collapsable bg
    menuCollapsableButton: "#F9F7F0",
    //number of guests bg
    numberOfGuestsActiveColor: "#303030",
    // estimated waitTime bg
    estimatedWaitTimeBg: "#54301A",
    // cart item qty color
    cartItemQuantityColor: "#54301A",
    mobileBottomTabBackgroundColor: "#FFFFFF",
    bottomTabTextColor: "#606060",
    checkoutGratuitySliderMinTrackColor: "#73994A",
    checkoutGratuitySliderMaxTrackColor: "#BFBFBF",
    cartQuantityTextColor: "#54301A",
    checkoutRadioBtnColor: "#73994A",
    // waitlistWineWhileYouWait Background color:
    waitlistWineWhileYouWaitBg: "#FFEFC2",
    homescreenWaitlistButtonBorderColor: "#73994A",
    homescreenWaitlistButtonTextColor: "#73994A",
    recentOrderTextColor: "#303030",
    orderConfirmationSeeDetailsShadowStart: "rgba(0, 0, 0, 0.02)",
    orderConfirmationSeeDetailsShadowEnd: "rgba(0, 0, 0, 0.05)",
    recentOrdersListItemPrice: "#73994A",
    menuLinearGradientStartColor: "#F8F8F8",
    menuLinearGradientEndColor: "#F8F8F8",
    paymentOrderTotalTextColor: "#000000",
    keyboardDoneButtonBgColor: "#FBFBFB",
    keyboardDoneButtonColor: "#2c7aff",
    profileHeaderLinearGradientStartColor: "#73994A",
    profileHeaderLinearGradientEndColor: "#73994A",
    profileAddCardButtonText: "#000000",
    searchBarBorderColor: "#D6D6D6",
    weekDayStartColor: "#223E6A",
    weekDayEndColor: "#223E6A",
    mobilePayConfirmationScreenBlockBG: "#F9F7F0",
    reservationCarouselActiveDotColor: "#DDC274",
    reservationCarouselInactiveDotColor: "#D5D8DA",
    reservationBorderColor: "rgba(0,0,0,0.1)",
    reservationButtonBGDisabled: "#CBD1D6",
    reservationSelectedCTABorderColor: "#73994A",
    reservationUnSelectedCTABorderColor: "transparent",
    reservationSelectedCTABGColor: "#F9F7F0",
    reservationUnSelectedCTABGColor: "#FFF",
    reservationPopupBgColor: "#fff",
    reservationSelectedSeatingOption: "#73994A26",
    reservationCalendarCtaBorderRadius: 0,
    reservationDOBMonthBgColor: "#fff",
    reservationDOBYearBgColor: "#fff",
    reservationDOBNavColor: "primary.100",
    reservationInputErrorColor: "#DF4505",
    locationsTopTabsContainerColor: "#FFFFFF",
    searchItemBreadCrumbSlugcolor: "#666666",
    preferredLocationHeaderBg: "#FFFFFF",
    preferredLocationHeaderTextColor: "#282C25",
    orderTotalTextColor: "#494949",
    orderTotalPriceColor: "#B31900",
    scrollingNavigationFlatlistStartingGradientStartColor: "#f8f8f8",
    scrollingNavigationFlatlistStartingGradientEndColor: "rgba(248, 248, 248, 0)",
    menuSearchModalCloseIconBg: "#F9F7F0",

    /* Restaurant Details */
    restaurantDetailsBGColor: "white",
    restaurantDetailsDividerColor: "rgba(0,0,0,0.2)",
    restaurantDetailsAboutSectionDividerColor: "rgba(0,0,0,0)",
    restaurantDetailsMobilePoliteNoticeDividerBg: "rgba(0,0,0,0.2)",
    restDetailsAmenitiesDividerMobileColor: "rgba(0,0,0,0.2)",
    restDetailsAmenitiesDividerColor: "transparent",
    restaurantDetailsJoinWaitlistButtonTextColor: "#73994A",
    restaurantDetailsJoinWaitlistButtonBorderColor: "#8F278A",
    restaurantDetailsJoinWaitlistButtonLargeTextColor: "white",
    restaurantDetailsDisableJoinWaitlistTextColor: "#C6C6C6",
    restaurantDetailsDisableJoinWaitlistButtonBorderColor: "#C6C6C6",
    restaurantDetailsCurrentStatusAndWaitlistDividerColor: "rgba(0,0,0,0.1)",
    restaurantDetailsRestInfoBoxBackgroundColor: "#F9F7F0",
    restaurantDetailsRestInfoLgDividerBackgroundColor: "#0000004D",
    restaurantDetailsSelectedWeekDayColor: "#73994A",
    restaurantDetailsNotSelectedWeekDayTextColor: "#404040",
    restaurantDetailsNotSelectedWeekDayColor: "#FFFFFF",
    restaurantDetailsCurrentWeekDayIndicator: "#49909B",
    restDetailsRestInfoTitleColor: "#70695C",
    mobilePayHeaderBtnBorder: "#73994A",
    restaurantInfoAddressTextColor: "#B31900",
    restaurantInfoAddToFavouritiesTextColor: "#73994A",
    restaurantTimingWeekDayTextColor: "#73994A",
    restaurantDetailsAmenetiesbgColor: "#FFFFFF",
    waitlistVisibilityAddressBoxArrow: "#54301A",
    howItWorksText: "#C16436",
    imageStackBorderColor: "#FFFFFF",
    calenderTodayBackgroundColor: "#73994A",
    calenderSelectedDayColor: "#73994A",
    calenderSelectedDayTextColor: "#FFF",
    calenderSelectedDayStyleBGColor: "#73994A",
    reserveTableHeaderRightButtonText: "#73994A",
    reserveConfirmationDescriptionHeaderBg: "#485062",
    defaultCardColor: "#rgba(255, 255, 255, 0.3)",
    defaultCardTextColor: "#FFFFFF",
    mobilePayBringYourCardArea: "#E0DED8",
    mobilePayCheckArea: "#F2F2F2",
    mobilePayCallInCheckDivider: "rgba(0, 0, 0, 0.1)",
    mobilePaySkeletonColor: "#DCDCDC",
    mobilePayCheckCloseBackgroundColor: "#F4F4F4",
    mobilePayCheckDividerColor: "rgba(0, 0, 0, 0.4)",
    mobilePayCheckBackground: "#FFFFFF",
    homescreenLocationTagBGColor: "rgba(255, 255, 255, 0.68)",
    homescreenLocationTagBorderColor: "#73994A",
    homescreenLocationTextColor: "#303030",
    homeScreenAlertBackgroundGradientOne: "#BE6336",
    homeScreenAlertBackgroundGradientTwo: "#4E332B",
    // location Search Token
    locationSearchTitle: "#303030",
    locationSearchSubTitle: "#020001",
    locationSearchActiveTab: "#73994A",
    searchThisAreaBg: "#73994A",
    locationSearchInActiveTab: "#606060",
    searchCurrentLocation: "#A2402A",
    registerLsBtn: "#73994A",
    allLocationsLsBg: "#F9F7F0",
    callRestLsText: "#73994A",
    mobilePayICheckError: "#3F3C3C",
    locationSearchTabDivider: "#DEDEDE",
    lsAllLocationsSelectBorder: "#D6D6D6",
    locationListingItemHeadingInPage: "#73994A",
    allLocationsLSPageBg: "#ffffff",
    locationSearchAddressColor: "#303030",
    locationsSearchPageLocationListItemBgColor: "#ffff",
    lsMyLocationsTabContentDivider: "#0000001a",
    hoursInfoAccordionIcon: "#73994A",
    hoursInfoAccordionTitle: "#73994A",
    joinWaitlistBtnHover: "white",
    joinWaitlistBtnTextHover: "#B31900",
    newLoctionsLinkText: "#ffffff",
    newLocationsBannerBg: "#73994A",
    viewMenuHover: "#73994A",
    loginScreenHeaderBackground: "white",
    loginScreenScrollBg: "white",
    createAccountZipCodeBg: "#FFFFFF",
    createAccountLocationCardBackgroundColor: "#FFFFFF",
    loginErrorMessageBg: "#FECACA",
    loginErrorMessageBorder: "#FCA5A5",
    preferredLocationScrollBg: "#FFFFFF",
    menuListingScrollBackground: "#FFFFFF",
    cartCheckoutButtonLinearGradientStart: "rgba(255,255,255,0.6)",
    cartCheckoutButtonLinearGradientEnd: "#FFF",
    menuListingTopTabsColor: "#FFF",
    cartHeaderTextColor: "#000",
    menuListingTopTabActiveBorderColor: "#73994A",
    dividerBackgroundColor: "#E5E5E5",
    moreHeaderTitleTextColor: "#000000",
    customMobileHeaderBG: "#FFFFFF",
    editProfileInfoCardBg: "#FFFFFF",
    addCardSecurityBannerBg: "#F6F7F0",
    mobileCreateAccountScrollBackgroundColor: "transparent",
    menuTopTabNotActiveTextColor: "#171717",
    menuTopTabActiveTextColor: "#73994A",
    checkoutTopTabActiveTextColor: "#171717",
    checkoutTopTabTextColor: "#171717",
    checkoutCardsBg: "transparent",
    orderInfoBannerCartSubTotalColor: "#B31900",
    orderSettingsCardsBackgroundColor: "transparent",
    orderSettingsActionSheetBackgroundColor: "#FFF",
    orderSettingsActionSheetAsapScheduledColor: "#B31900",
    menuItemDetailMenuSummaryBackgroundColor: "#FFF",
    menuitemDetailScreenBackgroundColor: "#FFF",
    cartHeaderBGColor: "#F6F6F6",
    nearbyLocationsListViewScrollViewBgColor: "#FFF",
    menuSearchResultsBg: "#fff",
    searchHeaderColor: "#fff",
    menuSearchPlaceHolder: "#606060",
    recentOrderDividerBg: "#E5E5E5",
    restDetailsTitleColor: "#2A2C25",
    restDetailsBg: "#fff",
    restDetailButtonBg: "#fff",
    recentOrderBorder: "#F9F7F0",
    topTabCountInactiveBg: "#DAD4D5",
    tooltipTextColor: "#fff",
    pickupDetailsBorder: "#D6D6D6",
    checkoutVehicleBg: "#fff",
    seeDetailsText: "#606060",
    orderSettingsQuantityBg: "#F9F7F0",
    criticalModeBg: "#fafafa",
    reorderAddItemBg: "#73994A",
    reorderAddItem: "#fff",
    orderHistoryItemCardBackgroundColor: "#FFF",
    orderHistoryItemCardPriceColor: "#B31900",
    orderHistoryHeaderTitleColor: "#2A2C25",
    orderHistoryDetailsOrderNumberTextColor: "#B31900",
    orderHistoryCardLayoutBackgroundColor: "#FFF",
    orderHistoryFooterBackgroundColor: "#FFF",
    orderHistoryHeaderBgColor: "#FFF",
    menuDetailsHeaderTitleColor: "#404040",
    selectedOrderTypeBorderColor: "#73994A",
    selectedOrderTypeTextColor: "#73994A",
    mobileCalendarTextColor: "#73994A",
    gcBalanceRefreshBorderTextColor: "#73994A",
    gcBalanceRefreshBackdropColor: "rgba(0, 0, 0, 0.6)",
    reservationLocationModalDeskHeaderBg: "#FFF",
    reservationLocationModalMobHeaderBg: "#FFF",
    reservationLocationListBg: "#FFF",
    reservationsSpecialRequestSwitch: "#97BC67",
    reservationBg: "#F6F6F6",
    reservationStaticTextBg: "#fff",
    reservationTabsBg: "#73994A",
    reservationDropDownIconColor: "#73994A",
    reservationPickerHoverColor: "#73994A",
    reservationNoOfGuestsSelectedBg: "#73994A",
    reservationNoOfGuestsNotSelectedBg: "white",
    reservationsTimePickerBg: "white",
    reservationActionButtonsBg: "white",
    reservationInactiveSelectTime: "#D8DCE0",
    confirmationModalBorderRadius: 0,
    cancelConfirmationModalBorderRadius: 0,
    reservationUserInitials: "#73994A",
    preferredLocationCloseButtonBg: "#F3F4EA",
    preferredLocationCloseButtonHover: "#A8AD00",
    preferredLocationModalContentColor: "#FFFFFF",
    preferredLocationCloseButtonIconColor: "#040101",
    reservationHoveredText: "#FFF",
    reservationNotHoveredText: "#606060",
    reservationsCardsBodyBg: "#F6F6F6",
    reservationSpecialRequests: "#FFFFFF",
    reservationDOBTooltipBgColor: "#e3e3e3",
    reservationDOBTooltipTextColor: "#000"
  },
  components: {
    Pressable: {
      variants: {
        /* RESERVATION */
        reservationLocationSelectionBtn: {
          borderRadius: 0,
          px: 6,
          backgroundColor: "secondary.300",
          alignItems: "center",
          justifyContent: "center"
        },
        reservationConfBackHomeBtn: {
          borderRadius: 0,
          alignItems: "center",
          justifyContent: "center",
          mb: 30,
          mx: 5,
          px: 5,
          mt: 5,
          borderWidth: 1,
          height: 12,
          borderColor: "secondary.300"
        },
        reservationSelectGuestBtn: {
          borderColor: "reservationBorderColor",
          borderWidth: 1,
          py: 3,
          px: 5,
          mx: 1.5,
          borderRadius: 0,
          _ios: {
            radiusValue: 6
          },
          _android: {
            radiusValue: 6
          }
        },
        reservationPickerBtn: {
          flex: 1,
          py: 2,
          _web: {
            py: 4,
            px: 4
          },
          _ios: {
            alignItems: "center"
          },
          _android: {
            alignItems: "center"
          },
          mx: 1.5,
          borderRadius: 0,
          justifyContent: "center"
        },
        reservationAvailableTimeSlotBtn: {
          borderColor: "reservationBorderColor",
          borderRadius: 0,
          mx: 2
        },

        /* RESERVATION */
        jwcPreOrderBtn: {
          px: 5,
          py: 4,
          bg: {
            base: "#A2402A",
            lg: "white"
          },
          borderRadius: {
            base: 8,
            lg: 12
          },
          _web: {
            my: 2
          },
          mx: 2
        },
        qualityStoryBtnCta: {
          px: 5,
          py: 4,
          bg: {
            base: "#ffffff",
            lg: "#ffffff"
          },
          borderRadius: {
            base: 8,
            lg: 12
          },
          _web: {
            my: 2
          },
          mx: 2
        },
        categoryActiveBorder: {
          borderBottomWidth: 3
        },
        suggestedSearchPill: {
          mt: 2,
          mb: 2,
          mr: 3,
          py: 2,
          px: 4,
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1,
          bg: "#FFFFFF",
          borderColor: "suggestionsBorderColor",
          borderRadius: 0
        },
        //Order Tracking
        orderTrackingCurbsideCheckPrimary: {
          bg: "payNowButtonBg",
          borderColor: "curbsideCheckInSecondary",
          borderWidth: 1,
          px: 5,
          py: 3,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "center"
        },
        orderTrackingCurbsideCheckSecondary: {
          bg: "#FFFFFF",
          borderColor: "curbsideCheckInSecondary",
          px: 5,
          py: 3,
          borderWidth: 1,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "center"
        },
        //Restaurant Details Start
        restaurantDetails_RestWaitlist_JoinWaitlistButton: function restaurantDetails_RestWaitlist_JoinWaitlistButton(_ref) {
          var disabled = _ref.disabled;
          return {
            borderColor: disabled ? "#BCBCBC" : "restaurantDetailsJoinWaitlistButtonTextColor",
            alignItems: "center",
            justifyContent: "center",
            borderWidth: 1,
            _ios: {
              py: 2
            },
            _android: {
              py: 2
            },
            bg: disabled ? "#BCBCBC" : "restaurantDetailsJoinWaitlistButtonTextColor",
            minWidth: {
              base: "70%",
              lg: "261px"
            },
            _web: {
              minH: "44px"
            }
          };
        },
        restaurantDetails_OrderButtonSection_OrderNowButton: function restaurantDetails_OrderButtonSection_OrderNowButton(_ref2) {
          var disabled = _ref2.disabled;
          return {
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "secondary.300",
            opacity: disabled ? 0.4 : 1,
            borderWidth: 1,
            width: "100%",
            disabled: disabled,
            _web: {
              minH: "44px",
              padding: 2
            },
            borderColor: "secondary.300"
          };
        },
        restaurantDetails_RestTimings_WeekDayIconButton: function restaurantDetails_RestTimings_WeekDayIconButton(_ref3) {
          var selectedDay = _ref3.selectedDay;
          return {
            borderRadius: 100,
            backgroundColor: selectedDay ? "restaurantDetailsSelectedWeekDayColor" : "restaurantDetailsNotSelectedWeekDayColor",
            width: 38,
            height: 38,
            borderColor: "weekDayBorderColor",
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center"
          };
        },
        restaurantDetails_ActionButtons_ApplyNowButton: function restaurantDetails_ActionButtons_ApplyNowButton() {
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            paddingY: 4,
            _web: {
              minH: "44px",
              padding: 2
            },
            borderWidth: 1,
            // width: "100%",
            backgroundColor: "secondary.300",
            borderColor: "secondary.300"
          };
        },
        restaurantDetails_ActionButtons_ViewMenuButton: function restaurantDetails_ActionButtons_ViewMenuButton() {
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            paddingY: 4,
            _web: {
              minH: "44px",
              padding: 2
            },
            backgroundColor: "secondary.300",
            borderWidth: 1,
            // width: "100%",
            borderColor: "secondary.300"
          };
        },
        restaurantDetails_RestaurantInfo_FavoriteButton: function restaurantDetails_RestaurantInfo_FavoriteButton() {
          return {
            bg: "white",
            w: "10",
            h: "10",
            shadow: 11,
            m: "auto",
            rounded: "full",
            position: "absolute",
            top: 2,
            right: 2
          };
        },
        restaurantDetails_RestInfo_ShareButton_Icon: {
          alignItems: "center",
          flexDirection: "row"
        },
        //Restaurant Details End
        locationListItemAddress: {
          pointerEvents: "none"
        },
        borderRadiusValue: function borderRadiusValue(_ref4) {
          var radiusValue = _ref4.radiusValue,
              topRadiusValue = _ref4.topRadiusValue,
              bottomRadiusValue = _ref4.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        viewCartBtnBorderRadius: {
          borderRadius: 0
        },
        homeScreen_order_button: function homeScreen_order_button() {
          return {
            shadow: 9,
            backgroundColor: "secondary.300",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            width: "90%"
          };
        }
      }
    },
    Button: {
      baseStyle: {
        _focusVisible: {
          style: {
            boxShadow: "none"
          }
        },
        borderRadius: "0px"
      },
      variants: {
        solid: {
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          },
          _hover: {
            bg: "#5A783A"
          }
        },
        ghost: {
          _pressed: {
            bg: "transparent"
          },
          _hover: {
            bg: "background.100"
          }
        },
        camAccessBtn: {
          bg: "#5A783A",
          paddingY: 18,
          marginTop: 27,
          marginX: 5,
          borderWidth: 1,
          w: "100%",
          _text: {
            fontSize: 18,
            lineHeight: 6,
            fontWeight: 400,
            color: "white",
            textTransform: "uppercase"
          }
        },
        socialLoginBtn: {
          bg: "transparent",
          mb: 4,
          border: 1,
          borderColor: "rgb(53,88,156)",
          _text: {
            fontWeight: 400,
            color: "rgb(53,88,156)"
          },
          _hover: {
            bg: "white"
          }
        },
        loginPopUpBtn: {
          height: 12,
          _web: {
            height: null
          },
          _text: {
            color: "white",
            fontWeight: 400
          },
          bg: "primary.100",
          _pressed: {
            bg: "primary.200"
          },
          _hover: {
            bg: "#5A783A"
          }
        },
        addMoreItemsButton: {
          _ios: {
            width: "100%",
            py: 4
          },
          _android: {
            width: "100%",
            py: 4
          },
          _web: {
            width: "100%",
            py: 2
          }
        },
        link: {
          _text: {
            textTransform: "uppercase",
            color: "white",
            fontWeight: "600",
            fontStyle: "normal",
            fontSize: "md",
            lineHeight: 6,
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            textAlign: "center",
            fontFamily: "heading"
          },
          _pressed: {
            bg: "transparent"
          }
        },
        outline: {
          _hover: {
            bg: "#E5EEDC"
          },
          _pressed: {
            bg: "#E5EEDC"
          }
        },
        HomeScreenCTAreserveNow: function HomeScreenCTAreserveNow(_ref5) {
          var borderRadiusValue = _ref5.borderRadiusValue;
          return {
            marginBottom: 5,
            borderRadius: 0,
            _text: {
              color: "#FFFFFF"
            },
            bg: "#73994A"
          };
        },
        HomeScreenCTAjwl: function HomeScreenCTAjwl(_ref6) {
          var borderRadiusValue = _ref6.borderRadiusValue;
          return {
            marginBottom: 5,
            marginTop: 0,
            borderRadius: 0
          };
        },
        HomescreenOrderOnlineCta: function HomescreenOrderOnlineCta(_ref7) {
          var borderRadiusValue = _ref7.borderRadiusValue;
          return {
            borderRadius: 0,
            borderWidth: 1,
            borderColor: "#73994A"
          };
        },
        orderOnlineBtn: function orderOnlineBtn() {
          return {
            padding: 0,
            _text: {
              color: "white",
              fontFamily: "body",
              fontWeight: 400,
              _web: {
                fontSize: "xs"
              },
              textTransform: "uppercase",
              margin: 2
            }
          };
        },
        orderOnlineBtnExternalLink: function orderOnlineBtnExternalLink() {
          return {
            padding: 0,
            _text: {
              color: "white",
              fontFamily: "body",
              fontWeight: 400,
              _web: {
                fontSize: "xs"
              },
              textTransform: "uppercase",
              margin: 2
            },
            border: 1,
            borderColor: "secondary.300",
            bg: "secondary.300",
            _hover: {
              bg: "secondary.300"
            },
            _pressed: {
              bg: "secondary.300"
            }
          };
        },
        changeLocationLink: {
          _text: {
            textTransform: "uppercase",
            _web: {
              fontSize: "xs"
            },
            fontWeight: "400",
            color: "#989182",
            fontStyle: "normal",
            lineHeight: 6,
            letterSpacing: "-0.3px",
            textAlign: "center",
            fontFamily: "heading"
          },
          _pressed: {
            bg: "transparent"
          },
          _hover: {
            _text: {
              underline: true
            }
          }
        },
        refreshIcon: {
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          backgroundColor: "white",
          borderColor: "#A2402A",
          _text: {
            fontSize: "xs",
            lineHeight: 4,
            textTransform: "uppercase",
            color: "secondary.300",
            fontWeight: 400
          }
        },
        cartItemActionButton: {
          _text: {
            color: "cartItemActionBtn",
            textTransform: "uppercase",
            lineHeight: 5,
            fontWeight: 500,
            _ios: {
              fontSize: "13",
              fontWeight: "400"
            },
            _android: {
              fontSize: "13",
              fontWeight: "400"
            },
            _web: {
              fontSize: "13px"
            }
          }
        },
        cartItemRemoveBtn: {
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          backgroundColor: "secondary.300",
          borderColor: "secondary.300",
          _text: {
            fontSize: "xs",
            lineHeight: 4,
            textTransform: "uppercase",
            color: "white",
            fontWeight: 400
          }
        },
        menuButton: function menuButton(_ref8) {
          var isActive = _ref8.isActive,
              isMobile = _ref8.isMobile,
              isLongText = _ref8.isLongText;
          return {
            px: {
              base: 2,
              md: 9
            },
            bg: isActive ? "menuButtonBackgroundColor" : "transparent",
            ml: isLongText && isMobile && 5,
            width: !isMobile && (isLongText ? "100%" : 32),
            height: {
              base: 8,
              md: 9
            },
            _web: {
              borderRadius: "0px",
              width: !isMobile && (isLongText ? "100%" : "117px")
            },
            borderRadius: 0,
            rounded: 0,
            _text: {
              color: isActive ? "white" : "menuButtonBackgroundColor",
              fontWeight: "600",
              fontSize: isMobile ? "xs" : "sm",
              _web: {
                lineHeight: isMobile ? "14.63px" : "24px",
                fontSize: {
                  base: "14px",
                  md: "14px"
                }
              },
              lineHeight: isMobile ? 4 : 6,
              textTransform: "uppercase",
              fontFamily: "heading"
            }
          };
        },
        pillButton: function pillButton(_ref9) {
          var isActive = _ref9.isActive;
          return {
            bg: isActive ? "secondary.100" : "transparent",
            _web: {
              borderRadius: "20px",
              height: "24px"
            },
            borderRadius: 5,
            height: 6
          };
        },
        exploreMenuButton: function exploreMenuButton() {
          return {
            bg: "white",
            border: 1,
            borderColor: "primary.100",
            _text: {
              color: "primary.100"
            }
          };
        },
        orderSettingsDateTimeChoiceSolidButton: function orderSettingsDateTimeChoiceSolidButton() {
          return {
            bg: "orderSettingsDateTimeChoiceColor"
          };
        },
        addToCartSolidButton: function addToCartSolidButton(_ref10) {
          var isUnavailable = _ref10.isUnavailable;
          return {
            bg: isUnavailable ? "#E5E5E5" : "primary.100",
            _pressed: {
              bg: isUnavailable ? "#E5E5E5" : "primary.100"
            },
            _hover: {
              bg: isUnavailable ? "#E5E5E5" : "primary.100"
            },
            _text: {
              fontWeight: "700"
            }
          };
        },
        addBtnPadding: function addBtnPadding() {
          return {
            _web: {
              paddingBottom: "8px"
            },
            paddingBottom: 2
          };
        },
        confirmationGradientButton: function confirmationGradientButton() {
          return {
            borderRadius: 0
          };
        },
        waitlistOrder: {
          backgroundColor: "white",
          borderColor: "#73994A",
          borderWidth: 1
        },
        menuSearchModalCloseButtonContainer: function menuSearchModalCloseButtonContainer() {
          return {
            _web: {
              marginRight: {
                base: "20px",
                md: "40px",
                lg: "110px"
              },
              marginTop: "26px",
              height: "48px",
              width: "48px",
              borderRadius: "8px"
            }
          };
        },
        //Restaurant Details Start
        restaurantDetails_RestInfo_GetDirectionsButton: function restaurantDetails_RestInfo_GetDirectionsButton() {
          return {
            variant: "outline",
            borderRadius: 8,
            alignItems: "center",
            justifyContent: "center",
            borderColor: "amenitiesActionButtonsColor",
            alignSelf: "flex-end",
            borderWidth: 1,
            bg: "white",
            _hover: {
              bg: "white"
            },
            _focus: {
              bg: "white"
            },
            _focusVisible: {
              bg: "white"
            },
            py: 2.5,
            px: 2
          };
        },
        //Restaurant Details End
        preorderDineIn: {
          backgroundColor: "#00A9A1"
        },
        // LS tokens
        locationListItemButton: {
          _text: {
            fontFamily: "s52",
            fontWeight: 600,
            fontSize: "18px"
          }
        },
        viewMenuBtn: {
          borderRadius: 0,
          padding: 0,
          borderWidth: 1,
          borderColor: "secondary.300",
          _text: {
            color: "secondary.300",
            marginY: "11px",
            marginX: 6,
            fontSize: "18px",
            fontWeight: 600,
            letterSpacing: -0.3,
            fontFamily: "S52-Regular",
            lineHeight: 4
          }
        },
        defaultBannerBtn: function defaultBannerBtn() {
          return {
            _web: {
              minW: 134,
              px: 4,
              py: 2
            },
            _ios: {
              px: 2,
              py: 2,
              mt: 0.5
            },
            _android: {
              px: 2,
              py: 2,
              mt: 0.5
            },
            px: 4,
            py: 2,
            borderWidth: 1,
            borderColor: "primary.200",
            bg: "primary.100"
          };
        },
        viewMenuBtnExternalLink: function viewMenuBtnExternalLink(_ref11) {
          var isLocationSearch = _ref11.isLocationSearch,
              fromAllLocations = _ref11.fromAllLocations;
          return {
            borderRadius: 0,
            padding: 0,
            borderWidth: 1,
            borderColor: "secondary.300",
            _text: {
              color: "secondary.300",
              marginY: "11px",
              marginX: 6,
              fontSize: "18px",
              fontWeight: 600,
              letterSpacing: -0.3,
              fontFamily: "S52-Regular",
              lineHeight: 4
            },
            bg: isLocationSearch && fromAllLocations ? "transparent" : "secondary.300",
            _hover: {
              bgColor: "secondary.300",
              _text: {
                color: "white"
              }
            },
            _pressed: {
              bgColor: "secondary.300"
            }
          };
        },
        locationListItemButtonBorderRadius: 0,
        locationsInfographicLoginButton: function locationsInfographicLoginButton() {
          return {
            pr: 12,
            pl: 12,
            py: 3,
            backgroundColor: "secondary.300",
            _web: {
              borderRadius: 6
            },
            _text: {
              color: "locationInfographicModalActionButtonTextColor",
              fontSize: 20,
              fontWeight: 400,
              textTransform: "uppercase",
              textAlign: "center",
              lineHeight: 6,
              borderRadius: 0
            }
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref12) {
          var radiusValue = _ref12.radiusValue,
              topRadiusValue = _ref12.topRadiusValue,
              bottomRadiusValue = _ref12.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        viewNutritionalVariant: {
          py: 1,
          mb: 2
        },
        confirmBtnBorderRadius: {
          borderRadius: 0
        },
        homeScreen_reserve_button: function homeScreen_reserve_button() {
          return {
            borderColor: "secondary.300",
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 8,
            width: "90%",
            bg: "bodyBg",
            _pressed: {
              bg: "bodyBg"
            },
            _text: {
              _ios: {
                fontSize: 18
              },
              _android: {
                fontSize: 18
              },
              _web: {
                fontSize: 18
              },
              color: "secondary.300",
              fontWeight: 400,
              lineHeight: 7,
              paddingTop: Platform.OS === "ios" ? 1 : 0,
              marginY: 0.5
            }
          };
        },
        joinWaitlist_Header_LoginButton: function joinWaitlist_Header_LoginButton() {
          return {
            _text: {
              fontSize: 14,
              color: "primary.100",
              fontWeight: 400
            },
            borderColor: "primary.100",
            borderRadius: 0,
            px: "17px",
            py: "10px",
            _web: {
              px: {
                base: "10px",
                lg: "17px"
              },
              py: {
                base: "6px",
                lg: "10px"
              }
            },
            _focus: {
              backgroundColor: "white"
            },
            bg: "transparent",
            borderWidth: 1
          };
        }
      }
    },
    Tooltip: {
      baseStyle: {
        borderRadius: 8,
        padding: 3,
        _text: {
          fontSize: 12,
          fontWeight: 500
        }
      }
    },
    Accordion: {
      baseStyle: {
        borderWidth: 0,
        borderColor: "transparent",
        borderRadius: 0
      },
      variants: {
        skuSelectorAccordion: function skuSelectorAccordion(_ref13) {
          var isMandatory = _ref13.isMandatory;
          return {
            borderRadius: {
              md: isMandatory && "xl"
            }
          };
        },
        menuItemAccordion: function menuItemAccordion() {
          return {
            borderRadius: {
              md: "0"
            }
          };
        }
      }
    },
    ModalHeader: {
      variants: {
        errorDialogModalHeader: {
          roundedTop: 8
        }
      }
    },
    ModalContent: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref14) {
          var radiusValue = _ref14.radiusValue,
              topRadiusValue = _ref14.topRadiusValue,
              bottomRadiusValue = _ref14.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        }
      }
    },
    AccordionSummary: {
      baseStyle: {
        borderTopWidth: 0,
        borderTopColor: "transparent",
        p: 0,
        _hover: {
          bg: "transparent"
        },
        _expanded: {
          bg: "transparent",
          borderBottomColor: "transparent",
          _text: {
            color: "white"
          }
        },
        _disabled: {
          bg: "transparent"
        }
      },
      variants: {
        skuSelectorSummary: function skuSelectorSummary(_ref15) {
          var isMandatory = _ref15.isMandatory;
          return {
            borderTopRadius: {
              md: isMandatory && "xl"
            }
          };
        }
      }
    },
    AccordionDetails: {
      variants: {
        skuSelectorDetails: function skuSelectorDetails(_ref16) {
          var isMandatory = _ref16.isMandatory;
          return {
            borderBottomRadius: {
              md: isMandatory && "xl"
            }
          };
        },
        menuItemDetails: function menuItemDetails(_ref17) {
          var isDefaultExpanded = _ref17.isDefaultExpanded;
          return {
            borderBottomRadius: {
              md: isDefaultExpanded && "0"
            }
          };
        }
      }
    },
    Stack: {
      variants: {
        skuSelectorItem: {
          borderRadius: 0
        },
        //Restaurant Details Start
        restaurantDetails_CurrentStatusAndWaitlist_AvailabilityStack: {
          alignItems: {
            lg: "flex"
          },
          _ios: {
            marginTop: 3
          },
          _android: {
            marginTop: 3
          },
          direction: {
            base: "row",
            lg: "column"
          },
          justifyContent: "space-between",
          space: "md"
        },
        restaurantDetails_CurrentStatusAndWaitlist_WaitTimeStack: {
          _ios: {
            marginRight: 4
          },
          _android: {
            marginRight: 4
          },
          direction: {
            base: "column",
            lg: "row"
          },
          alignItems: "center",
          space: {
            lg: "sm"
          }
        },
        restaurantDetails_RestInfo_AddressLink_Stack: {
          direction: {
            base: "column",
            lg: "row"
          }
        } //Restaurant Details End

      }
    },
    Divider: {
      variants: {
        restaurantDetails_RestInfo_Divider: {
          mx: 5
        },
        jwcFooterBlockDivider: {
          height: 4,
          backgroundColor: "#8A8585",
          orientation: "vertical",
          mx: 3.5,
          w: 0.4
        }
      }
    },
    Text: {
      variants: {
        /* RESERVATION */
        reservationListHeaderUpcoming: {
          fontSize: 18,
          fontWeight: 800,
          pb: 4
        },
        reservationCancelSuccessHeader: {
          fontSize: 20,
          fontWeight: 500,
          textAlign: "center",
          color: "#70695C"
        },
        reservationPoliteDressText: {
          fontSize: 14,
          fontWeight: 300,
          pt: 2
        },
        reservationMakeNewReservationCTA: {
          fontWeight: 500,
          fontSize: 20,
          color: "primary.100",
          textAlign: "center"
        },
        reservationCancelSuccessBody: {
          fontSize: 16,
          fontWeight: 200,
          lineHeight: 5,
          textAlign: "center",
          color: "#70695C"
        },
        joinWaitlist_Header_Logout: function joinWaitlist_Header_Logout() {
          return {
            textAlign: "end",
            textTransform: "uppercase",
            fontSize: 16,
            mt: 1,
            color: "primary.100"
          };
        },
        joinWaitlist_Header_MyAcc: function joinWaitlist_Header_MyAcc() {
          return {
            textAlign: "end",
            textTransform: "uppercase",
            fontSize: 16,
            mt: 1,
            color: "primary.100"
          };
        },
        joinWaitlist_Header_MyAcc_Mobile: function joinWaitlist_Header_MyAcc_Mobile() {
          return {
            fontSize: 8,
            mt: 1,
            color: "primary.100"
          };
        },
        reservtionPredferedLocationCardAddress: {
          fontWeight: "300",
          fontSize: 12,
          lineHeight: 4
        },
        reservationConfirmationDateTimeSizeText: {
          fontWeight: 500,
          lineHeight: 5,
          fontSize: 14
        },
        reservationConfirmationRestaurantName: {
          fontSize: {
            base: 14,
            md: 16
          },
          lineHeight: 5,
          fontWeight: 400,
          flexWrap: "wrap"
        },
        reservationConfirmationLocationAddress: {
          fontSize: {
            base: 12,
            md: 14
          },
          fontWeight: 200,
          lineHeight: 5,
          flexWrap: "wrap"
        },
        reservationConfirmationDirectionsText: {
          fontWeight: 500
        },
        reservationsSelectFromAvailableSlotsTitle: {
          fontWeight: 600
        },
        reservationsReviewReservationsText: {
          fontWeight: 600
        },
        reservationsChangeLocationChangeText: {
          color: "primary.100",
          textTransform: "uppercase",
          fontSize: {
            base: "2xs",
            md: "sm"
          },
          fontWeight: 400
        },
        reservationThankyouConfirmationText: {
          fontSize: 18,
          fontWeight: 600,
          pb: 2,
          color: "primary.100",
          textAlign: "center"
        },
        reservationThankyouConfirmationSubText: {
          fontSize: 16,
          fontWeight: 600,
          textAlign: "center"
        },
        reservationSelectGuestText: {
          fontSize: 14,
          fontWeight: 400
        },
        reservationLocationCardHeader: {
          fontSize: {
            base: 14,
            md: 16
          },
          lineHeight: 5,
          fontWeight: 400
        },
        reservationLocationCardAddress: {
          lineHeight: 5,
          fontSize: 14,
          fontWeight: 200
        },
        reservationLocationModalHeaderText: {
          color: "#282C25",
          fontSize: 20,
          fontWeight: 300,
          textAlign: "center"
        },
        reservationFilterStateHeading: {
          fontSize: 20,
          color: "#2A2C25",
          fontWeight: 600,
          ml: {
            base: 0,
            md: 4
          },
          mt: {
            base: 4,
            md: 0
          },
          textTransform: "capitalize"
        },
        reservationTabsText: function reservationTabsText(_ref18) {
          var isActive = _ref18.isActive;
          return {
            textAlign: "center",
            color: isActive ? "#000" : "#FFF",
            fontSize: {
              base: 18,
              md: 20
            },
            mt: 2
          };
        },
        reservationDetailsHeaderText: {
          px: 5,
          fontSize: 20,
          fontWeight: 400,
          lineHeight: 5,
          color: "#70695C"
        },
        reservationPickerTopLabelText: {
          pb: 2,
          noOfLines: 1,
          fontSize: 12,
          color: "#707070",
          _web: {
            pb: 0,
            mb: {
              base: 1,
              md: 0
            }
          }
        },
        reservationPickerLabelText: {
          pt: 2,
          noOfLines: 1,
          fontSize: 12,
          _web: {
            pt: 0,
            mt: 1,
            width: "min-content",
            borderBottomWidth: 1
          }
        },
        reservationAddDetailsHeading: {
          px: 5,
          fontSize: 20,
          fontWeight: 400,
          lineHeight: 5,
          color: "grey300"
        },

        /* RESERVATION */
        advanceOrderMessageText: {
          fontWeight: 400,
          color: "#FF0000",
          fontSize: [12, 12, 14, 14, 14]
        },
        noCheckHeaderText: {
          fontFamily: "body",
          fontWeight: 500,
          fontSize: 22,
          lineHeight: 26,
          color: "#303030"
        },
        errorDialogBoxTitle: {
          fontSize: "lg",
          fontWeight: 400
        },
        OnboardingScreenTitleTextColor: {
          color: "#222828"
        },
        OrderInfoBannerCartIconText: {
          _web: {
            pt: 1
          }
        },
        LoginHeaderText: {
          _web: {
            pt: 1
          }
        },
        checkoutTopLabelText: {
          _web: {
            pt: 1
          }
        },
        CheckOutHeaderText: {
          ml: 1
        },
        //checkDetails Start
        cdHeaderText: {
          fontSize: 16,
          lineHeight: 5,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdCheckItemsText: {
          fontSize: 16,
          lineHeight: 5,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        RecommendedPairingText: {
          color: "#989182"
        },
        cdBillingTileText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdTableDetailTileText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        successDialogTitleText: {
          lineHeight: 4
        },
        successDialogDescText: {
          _ios: {
            lineHeight: 4
          },
          _android: {
            lineHeight: 4
          }
        },
        orderConfirmationMobileNumberText: {
          lineHeight: 3
        },
        //checkDetails End
        // checkSummaryStart
        paymentCompleteText: {
          fontSize: 18,
          fontWeight: 400,
          lineHeight: 6,
          color: "#73994A"
        },
        checkSummaryTitle: {
          fontSize: 18,
          color: "#303030",
          fontWeight: 500,
          fontFamily: "headingSecondary",
          lineHeight: 6
        },
        checkSummaryBodyText: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 5,
          color: "#303030"
        },
        checkSummaryEmailText: {
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 5,
          color: "#020001"
        },
        checkSummarySurveyText: {
          color: "secondary200Mobile",
          fontWeight: 500,
          lineHeight: 6,
          fontSize: 14
        },
        checkSummaryPriceText: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 5,
          color: "#303030"
        },
        totalPriceText: {
          fontSize: 16,
          fontWeight: 700,
          lineHeight: 6,
          color: "#303030",
          fontFamily: "headingSecondary"
        },
        preAppliedDeductionPrice: {
          fontSize: 16,
          fontWeight: 700,
          lineHeight: 5
        },
        // checkSummaryEnds
        paymentTileTitle: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          color: "#303030"
        },
        paymentTilePrice: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          color: "#73994a"
        },
        viewCheckText: {
          color: "#782434",
          fontWeight: 400,
          fontSize: 15,
          lineHeight: 5,
          textTransform: "uppercase"
        },
        paymentMethodsText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 500,
          color: "#303030"
        },
        emailReceiptText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 500,
          color: "#303030"
        },
        snackBarText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "#303030"
        },
        snackBarPrice: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "secondary.300"
        },
        addGratuityText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "#303030"
        },
        camAccessText: {
          color: "#737373",
          lineHeight: 6,
          fontSize: 14
        },
        camAccessLinkText: {
          textDecoration: "underline",
          color: "primary.100"
        },
        gratuityTipNumbers: {
          fontSize: 15,
          fontFamily: "S52-Regular",
          color: "themeGrey",
          lineHeight: 3
        },
        stepsToMobilePayHeader: {
          fontFamily: "headingSecondary",
          fontSize: 28,
          color: "#303030",
          textTransform: "uppercase",
          ml: 5
        },
        mobilePayStepsHeading: {
          fontFamily: "body",
          fontWeight: 500,
          fontSize: 16,
          mt: 4,
          ml: 5,
          color: "#782434",
          _web: {
            letterSpacing: "-0.29px"
          },
          letterSpacing: "-0.29"
        },
        mobilePayStepsBody: {
          fontFamily: "body",
          fontWeight: 200,
          fontSize: 11,
          color: "#303030"
        },
        mobilePayVisitLink: {
          display: "block",
          position: "absolute",
          fontSize: 12,
          lineHeight: 12,
          opacity: "0.4",
          color: "#1B1B1B",
          bottom: "42%",
          left: {
            base: "36%",
            sm: "36%",
            md: "42%",
            lg: "45%"
          },
          textAlign: "center"
        },
        remoteCheckinNoteText: {
          _android: {
            lineHeight: 5
          },
          _ios: {
            lineHeight: 5
          },
          mt: 3,
          _web: {
            fontSize: "14px"
          },
          fontSize: "sm",
          fontWeight: 300,
          textAlign: "center"
        },
        //JWC STARTS
        jwcLeaveTheLineCancelBtn: {
          fontSize: 16,
          fontWeight: 400,
          color: "primary.100"
        },
        jwcLeaveTheLineContinueBtn: {
          fontSize: 16,
          fontWeight: 400
        },
        jwcLeaveTheLineModalTitle: {
          fontSize: 16,
          color: "#303030",
          fontFamily: "headingSecondary",
          textTransform: "uppercase"
        },
        jwcLeaveTheLineModalBody: {
          fontWeight: 300,
          fontSize: {
            base: 18,
            lg: 14
          },
          lineHeight: {
            base: 25,
            lg: 18
          },
          color: {
            base: "#606060",
            lg: "#020001"
          }
        },
        jwcEstWaitTimePrefix: {
          textAlign: "center",
          fontSize: 14,
          fontWeight: 300,
          lineHeight: 6,
          color: "#54301A"
        },
        jwcEstWaitTime: {
          lineHeight: 10,
          fontWeight: 400,
          textAlign: "center",
          fontSize: 32,
          color: "#54301A"
        },
        jwcRestDetails: {
          color: "#80603D",
          lineHeight: 4,
          fontSize: 12,
          fontWeight: 300
        },
        jwcRestName: {
          color: "#80603D",
          fontSize: 15,
          fontWeight: 400
        },
        jwcHowItWorksText: {
          fontSize: 14,
          fontWeight: 300,
          color: "white",
          textAlign: "center"
        },
        jwcOrderWhileYouWaitText: {
          textAlign: "center",
          color: {
            base: "white",
            lg: "#A2402A"
          },
          fontSize: 16,
          fontWeight: 400
        },
        qualityStoryCtaText: {
          textAlign: "center",
          color: {
            base: "#73994a",
            lg: "#73994a"
          },
          fontSize: 16,
          fontWeight: 400
        },
        jwcOrderAheadText: {
          fontSize: {
            base: 22,
            lg: 28
          },
          fontWeight: 600,
          color: "white",
          lineHeight: 32,
          textAlign: "center"
        },
        qualityStoryDescText: {
          fontSize: {
            base: 21,
            lg: 28
          },
          fontWeight: 600,
          color: "white",
          lineHeight: 32,
          textAlign: "center"
        },
        jwcHeaderDirectionsText: {
          color: "#A2402A",
          fontSize: 14
        },
        jwcHeaderLocationName: {
          color: "#303030",
          fontSize: 16,
          fontWeight: 300
        },
        jwcViewPdfMenu: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 300
        },
        jwcLeaveTheLine: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 300
        },
        jwcWaitTimeVary: {
          textAlign: "center",
          fontWeight: 300,
          fontSize: 18,
          color: " #2A2C25",
          lineHeight: 24
        },
        jwcPartySizeNumber: {
          fontWeight: 400,
          fontSize: 17,
          color: "#54301A"
        },
        jwcPartySize: {
          fontWeight: 300,
          fontSize: 17,
          color: "#54301A"
        },
        jwcTitle: {
          textAlign: "center",
          fontSize: 24,
          fontWeight: 500,
          color: "#54301A",
          mt: 6
        },
        jwcTitleText: {
          textAlign: "center",
          fontSize: 24,
          fontWeight: 500,
          color: "#54301A",
          mb: 4,
          mx: 1,
          lineHeight: 7,
          _ios: {
            mx: 2
          },
          _android: {
            mx: 2
          }
        },
        waitListFooterText: {
          marginTop: 2,
          fontSize: 14,
          fontWeight: 300,
          maxWidth: 74,
          textAlign: "center"
        },
        refreshIconText: {
          textTransform: "uppercase",
          fontSize: 12,
          color: "#A2402A",
          lineHeight: 14
        },
        waitlistCheckbackSoonTitle: {
          color: "#54301A",
          fontWeight: 300,
          fontSize: 20,
          lineHeight: 20
        },
        waitlistCheckbackSoonBody: {
          color: "#606060",
          pt: 4,
          fontWeight: 300,
          fontSize: 16,
          lineHeight: 20
        },
        leaveTheLineText: {
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16
        },
        leaveTheLineLinkText: {
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16
        },
        leaveWaitlistErrorModal: {
          fontWeight: 300,
          fontSize: 18,
          lineHeight: 25,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#606060"
        },
        waitlistErrorTitle: {
          fontWeight: 500,
          fontSize: 24,
          lineHeight: 24,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#2A2C25"
        },
        waitlistErrorBody: {
          fontWeight: 300,
          fontSize: 20,
          lineHeight: 28,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#606060",
          mt: 2,
          textAlign: "center",
          maxWidth: 253
        },
        waitTimeText: {
          checkinSuccessNoteTitleText: {
            color: "#FFFFFF",
            pt: 3,
            fontSize: 22,
            lineHeight: 42,
            _web: {
              letterSpacing: "-0.5px"
            },
            letterSpacing: "-0.5"
          },
          checkinSuccessNoteBodyText: {
            color: "#FFFFFF",
            pt: 1,
            maxWidth: 173,
            textAlign: "center",
            fontWeight: 300,
            fontSize: 14,
            lineHeight: 16,
            _web: {
              letterSpacing: "-0.5px"
            },
            letterSpacing: "-0.5"
          },
          fontWeight: 400,
          fontSize: 14,
          lineHeight: 16,
          mb: 2
        },
        waitTimeMins: {
          fontWeight: 400,
          fontSize: 32,
          lineHeight: 36
        },
        remoteCheckinWaitTimeThankYou: {
          fontSize: 24,
          fontWeight: 600,
          _web: {
            letterSpacing: "-0.3px"
          },
          letterSpacing: "-0.3"
        },
        remoteCheckinWaitTimePartySize: {
          fontSize: 14,
          fontWeight: 300,
          lineHeight: 14
        },
        remoteCheckinWaitTimeNote: {
          fontSize: 14,
          fontWeight: 100,
          lineHeight: 4
        },
        remoteCheckinRefreshBtn: {
          color: "remoteCheckinRefreshBtnColor",
          fontSize: 12,
          fontWeight: 600,
          marginY: 11,
          marginX: 5
        },
        confirmAndAddToCart: {
          textTransform: "uppercase",
          color: "white",
          fontWeight: 600
        },
        startingAtPrice: {
          color: "black",
          fontSize: 16,
          fontWeight: 500
        },
        startingAtText: {
          color: "black",
          fontSize: 16,
          fontWeight: 500
        },
        menuItemInfoPrice: {
          fontWeight: 300
        },
        categoryText: function categoryText(_ref19) {
          var isActive = _ref19.isActive;
          return {
            fontSize: {
              base: "sm",
              md: "sm"
            },
            fontWeight: isActive ? "600" : "400"
          };
        },
        noThanksText: {
          fontFamily: "heading",
          fontSize: "xl",
          textDecoration: "underline",
          textDecorationColor: "white",
          textAlign: "center",
          color: "white",
          _web: {
            fontSize: "28px",
            mt: 5
          },
          _ios: {
            mt: 0,
            fontSize: "16px",
            lineHeight: 8,
            letterSpacing: "-0.37",
            fontWeight: "400"
          },
          _android: {
            mt: 0,
            fontSize: "16px",
            lineHeight: 8,
            letterSpacing: "-0.37",
            fontWeight: "400"
          }
        },
        youMayLikeText: {
          fontFamily: "headingSecondary",
          fontSize: "3xl"
        },
        orderTypeText: {
          fontSize: "sm",
          fontWeight: "300"
        },
        nutritinalInfo: {
          _web: {
            fontSize: "18px"
          },
          fontWeight: 400
        },
        globalBannerCareer: function globalBannerCareer() {
          return {
            textTransform: "uppercase",
            fontWeight: 200,
            color: "#70695c",
            fontSize: {
              base: "10px",
              md: "10px",
              lg: "13px"
            },
            right: 0
          };
        },
        menuItemNameWeight: function menuItemNameWeight(_ref20) {
          var isFromSmartRecsOrFrequentlyOrdered = _ref20.isFromSmartRecsOrFrequentlyOrdered;
          return {
            fontWeight: 300,
            fontSize: [14, 14, 14, isFromSmartRecsOrFrequentlyOrdered ? 14 : 20]
          };
        },
        listDescriptionText: function listDescriptionText() {
          return {
            _web: {
              fontSize: 14,
              fontWeight: 300,
              fontFamily: "heading"
            }
          };
        },
        categoryFontSize: function categoryFontSize() {
          return {
            _web: {
              fontSize: {
                base: "36px",
                md: "60px"
              }
            },
            _ios: {
              fontSize: [26, 26, 36]
            },
            _android: {
              fontSize: [26, 26, 36]
            },
            fontWeight: 600,
            fontFamily: "S52-Regular"
          };
        },
        subCategoryFontSize: function subCategoryFontSize() {
          return {
            // TODO: desktop UI
            _web: {
              fontSize: {
                base: "26px",
                md: "46px"
              }
            },
            _ios: {
              fontSize: [18, 18, 28]
            },
            _android: {
              fontSize: [18, 18, 28]
            },
            fontWeight: 600,
            fontFamily: "S52-Regular"
          };
        },
        subSubCategoryFontSize: function subSubCategoryFontSize() {
          return {
            // TODO: desktop UI
            _web: {
              fontSize: {
                base: "16px",
                md: "28px"
              }
            },
            _ios: {
              fontSize: [16, 16, 24]
            },
            _android: {
              fontSize: [16, 16, 24]
            },
            color: "#70695C",
            fontWeight: 600
          };
        },
        locationText: {
          color: "#989182",
          fontSize: "sm",
          fontFamily: "body"
        },
        phoneNumberText: {
          color: "#989182",
          fontSize: "sm",
          fontFamily: "body"
        },
        btnText: {
          color: "#989182",
          fontFamily: "heading"
        },
        headerText: {
          color: "primary.100",
          fontSize: 32,
          fontWeight: 300
        },
        cartItemCancelText: {
          fontSize: 13,
          lineHeight: 4,
          textTransform: "uppercase",
          color: "secondary.300",
          fontWeight: 500
        },
        checkoutText: {
          fontSize: "xl",
          lineHeight: 6,
          fontWeight: 400,
          color: "white",
          textTransform: "uppercase"
        },
        addMoreItemsText: {
          fontSize: "md",
          fontWeight: 600,
          lineHeight: 5,
          textTransform: "uppercase",
          color: "secondary.300"
        },
        checkoutPriceText: {
          fontSize: 22,
          lineHeight: 5,
          fontWeight: 400,
          color: "white"
        },
        menuItemDetailsPropertyAccordionHeading: function menuItemDetailsPropertyAccordionHeading(_ref21) {
          var isMandatory = _ref21.isMandatory;
          return {
            _web: {
              // TODO: desktop font size | styles
              fontSize: {
                base: "md",
                md: "2xl"
              },
              letterSpacing: "-0.3px"
            },
            _android: {
              letterSpacing: 1
            },
            _ios: {
              letterSpacing: 1
            },
            lineHeight: {
              base: 7,
              md: 10
            },
            fontWeight: 500,
            color: isMandatory ? "white" : "menuDetailAccordionTextColor",
            fontFamily: "headingSecondary",
            textTransform: "capitalize"
          };
        },
        skuMenuItemDetailsPropertyAccordionHeading: function skuMenuItemDetailsPropertyAccordionHeading(_ref22) {
          var isMandatory = _ref22.isMandatory;
          return {
            _web: {
              // TODO: desktop font size | styles
              fontSize: {
                base: "md",
                md: "2xl"
              },
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            lineHeight: {
              base: 7,
              md: 10
            },
            fontWeight: 500,
            color: isMandatory ? "white" : "menuDetailAccordionTextColor",
            fontFamily: "headingSecondary",
            textTransform: "capitalize"
          };
        },
        menuItemDetailsQuestionVarient: function menuItemDetailsQuestionVarient(_ref23) {
          var isMobile = _ref23.isMobile;
          return {
            _web: {
              fontSize: {
                base: "2xl",
                md: "md"
              },
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            lineHeight: {
              base: 7,
              md: 5
            },
            fontWeight: {
              base: 300,
              md: 500
            },
            color: "themeTextColor",
            textTransform: isMobile && "uppercase",
            fontFamily: isMobile ? "headingSecondary" : "body"
          };
        },
        menuItemDetailsIsRequiredMark: function menuItemDetailsIsRequiredMark() {
          return {
            fontSize: {
              base: "xs",
              md: "md"
            },
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            fontWeight: 300,
            color: "white",
            lineHeight: {
              base: 4,
              md: 5
            },
            alignSelf: "center"
          };
        },
        menuItemDetailsPropertyAccordionRightText: function menuItemDetailsPropertyAccordionRightText() {
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            lineHeight: 5,
            color: "white",
            _web: {
              letterSpacing: "-0.3 px"
            },
            letterSpacing: "-0.3"
          };
        },
        menuDetailPropertyAccordionDescription: function menuDetailPropertyAccordionDescription(_ref24) {
          var isDefaultExpanded = _ref24.isDefaultExpanded;
          return {
            fontSize: {
              base: "xs",
              md: "md"
            },
            lineHeight: {
              base: 4,
              md: 5
            },
            fontWeight: 400,
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            color: isDefaultExpanded ? "white" : "#989182"
          };
        },
        menuDetailErrorText: function menuDetailErrorText() {
          return {
            fontSize: "xs",
            color: "white",
            fontWeight: 400,
            lineHeight: 4
          };
        },
        mobilePayHeaderBtnText: function mobilePayHeaderBtnText() {
          return {
            fontSize: {
              base: 14,
              md: 18
            },
            fontWeight: 400,
            color: "secondary.300"
          };
        },
        confirmPickupDetailsChangeBtnText: function confirmPickupDetailsChangeBtnText() {
          return {
            fontSize: 14,
            fontWeight: 700,
            color: "orderConfirmationTextColor"
          };
        },
        confirmPickupDetailsText: function confirmPickupDetailsText() {
          return {
            color: "orderConfirmationTextColor",
            fontWeight: 400,
            lineHeight: 4,
            fontSize: 12,
            _web: {
              letterSpacing: "2px"
            },
            letterSpacing: 1
          };
        },
        menuItemInfoName: function menuItemInfoName() {
          return {
            mb: 2,
            _web: {
              fontSize: ["xl", "xl", "24px"]
            },
            fontSize: ["xl", "xl", 10],
            fontWeight: 300
          };
        },
        menuItemInfoPriceStartingAt: function menuItemInfoPriceStartingAt() {
          return {
            _web: {
              fontSize: {
                base: "13px",
                md: "18px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            },
            fontWeight: 400
          };
        },
        orderSettingsText: function orderSettingsText() {
          return {
            fontWeight: "600",
            fontSize: "sm"
          };
        },
        backToMenu: {
          fontFamily: "headingSecondary",
          fontSize: "xl",
          lineHeight: 6
        },
        emptyCartText: {
          fontSize: "lg",
          fontWeight: 300,
          lineHeight: 6
        },
        addToCardButtonPriceText: function addToCardButtonPriceText() {
          return {
            color: "white",
            fontSize: {
              base: "sm",
              md: "xl"
            },
            _web: {
              fontSize: {
                base: "14px",
                md: "24px"
              }
            },
            fontWeight: 400,
            fontFamily: "heading"
          };
        },
        addToCardButtonText: function addToCardButtonText() {
          return {
            color: "white",
            fontSize: {
              base: "sm",
              md: "xl"
            },
            _web: {
              fontSize: {
                base: "14px",
                md: "24px"
              }
            },
            fontWeight: 400,
            fontFamily: "heading"
          };
        },
        allLocationsSelectHeading: {
          fontSize: 28,
          fontWeight: 600,
          color: "#989182"
        },
        allLocationsSelectText: {
          fontSize: {
            base: 16,
            md: 20
          },
          fontWeight: 600,
          color: "#989182"
        },
        allLocationsText: function allLocationsText(_ref25) {
          var isLocationSearchPage = _ref25.isLocationSearchPage;
          return {
            fontSize: 20,
            color: isLocationSearchPage ? "#2A2C25" : "#739849",
            fontWeight: 600
          };
        },
        allLocationsLengthText: {
          fontSize: 16,
          color: "#606060",
          fontWeight: 300
        },
        addBtnText: function addBtnText(_ref26) {
          var addButtonText = _ref26.addButtonText;
          return {
            color: "white",
            textTransform: "uppercase",
            fontSize: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? 10 : 18,
            overflowWrap: "break-word",
            maxWidth: {
              base: "70px",
              md: "110px"
            },
            textAlign: "center",
            marginBottom: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "2px" : 0,
            _ios: {
              maxWidth: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "100%" : "70px"
            },
            _android: {
              maxWidth: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "100%" : "70px"
            }
          };
        },
        menuItemPrice: {
          fontSize: {
            base: 12,
            lg: 16
          },
          fontWeight: 500,
          pr: 1
        },
        menuItemCalorieText: {
          fontSize: [12, 12, 16],
          fontWeight: 300,
          pl: 1
        },
        confirmPickupDetailsHeaderText: {
          textTransform: "uppercase",
          fontSize: 16,
          color: "#72994C",
          fontWeight: 600,
          fontFamily: "headingSecondary"
        },
        confirmPickupDetailsRestaurant: {
          fontSize: 14,
          color: "#989182",
          fontWeight: 600
        },
        menuListTextCTA: {
          fontWeight: 300,
          fontSize: [10, 10, 14, 16, 16]
        },
        cartHeaderLocationName: {
          color: "primary.100",
          fontWeight: 600
        },
        cartItemMenuName: {
          color: "menuItemNameColor",
          fontWeight: 500,
          fontSize: 17
        },
        cartItemPrice: function cartItemPrice() {
          return {
            fontSize: "sm"
          };
        },
        cartMessageText: function cartMessageText() {
          return {
            fontWeight: 300,
            fontSize: "xs"
          };
        },
        checkoutNoOfItems: function checkoutNoOfItems() {
          return {
            fontSize: "xs",
            pt: 2,
            _web: {
              pt: "6px"
            }
          };
        },
        cartHeaderOrderType: {
          fontWeight: 300,
          color: "#989182"
        },
        cartItemRemoveText: {
          fontSize: 13,
          lineHeight: 4,
          textTransform: "uppercase",
          color: "white",
          fontWeight: 500
        },
        reorderAddButtonText: {
          fontSize: 18,
          fontWeight: 600,
          color: "reOrderAddBtnBorder"
        },
        pdfMenuButtonText: {
          my: 1,
          _web: {
            mt: 0
          }
        },
        locationListRestaurantName: function locationListRestaurantName(_ref27) {
          var isFromLocationSearch = _ref27.isFromLocationSearch;
          return {
            fontWeight: isFromLocationSearch ? 600 : 400,
            fontSize: isFromLocationSearch ? "24px" : "sm",
            lineHeight: 18,
            textAlign: "left",
            color: "#989182",
            fontFamily: isFromLocationSearch ? "S52-Regular" : "Barlow-Medium"
          };
        },
        locationListRestaurantDetails: function locationListRestaurantDetails(_ref28) {
          var isFromLocationSearch = _ref28.isFromLocationSearch;
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            _web: {
              width: isFromLocationSearch ? "100%" : "70%",
              lineHeight: "18px"
            },
            fontWeight: 300,
            lineHeight: 14
          };
        },
        locationListResturantAddressSecondLine: {
          marginTop: 1,
          marginBottom: 0.5
        },
        confirmationPickupRestName: {
          fontSize: {
            base: 12,
            lg: 16
          },
          lineHeight: 3
        },
        confirmationPickupResAdd1: {
          lineHeight: 4,
          marginBottom: 1
        },
        confirmationPickupResAdd2: {
          lineHeight: 4
        },
        confirmationSurveyHeader: function confirmationSurveyHeader() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationSurveyText: function confirmationSurveyText() {
          return {
            color: "confirmationThemeDark",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        // @ts-ignore
        confirmationEclubHeader: function confirmationEclubHeader() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationEclubEmail: function confirmationEclubEmail() {
          return {
            color: "confirmationThemeDark"
          };
        },
        confirmationEclubChangeEmail: function confirmationEclubChangeEmail() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationEclubCheckboxText: function confirmationEclubCheckboxText() {
          return {
            color: "confirmationThemeDark"
          };
        },
        confirmationAccountHeader: function confirmationAccountHeader() {
          return {
            color: "#70695c",
            fontSize: {
              base: 16,
              lg: 20
            },
            fontWeight: "600",
            fontFamily: "heading"
          };
        },
        confirmationAccountEmail: function confirmationAccountEmail() {
          return {
            color: "confirmationThemeDark",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationPickupMyOrderHeader: function confirmationPickupMyOrderHeader() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationPickupDetailsHeader: function confirmationPickupDetailsHeader() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationPickupDetailsSubTitle: function confirmationPickupDetailsSubTitle() {
          return {
            color: "confirmationAccentDark",
            fontSize: {
              base: 12,
              lg: 13
            }
          };
        },
        confirmationThankYouTitle: function confirmationThankYouTitle() {
          return {
            color: "#70695c",
            _ios: {
              color: "#73994A",
              fontSize: 18,
              textTransform: "capitalize"
            },
            _android: {
              color: "#73994A",
              fontSize: 18,
              textTransform: "capitalize"
            },
            fontSize: {
              base: 24,
              lg: 42
            },
            letterSpacing: {
              base: "-0.5px",
              lg: "-2px"
            },
            fontWeight: "600",
            fontFamily: "heading",
            _web: {
              fontFamily: "heading"
            }
          };
        },
        confirmationThankYouMailText: function confirmationThankYouMailText() {
          return {
            color: "#494949",
            fontSize: {
              base: 18,
              lg: 22
            },
            fontWeight: "300",
            fontFamily: "S52-Light",
            letterSpacing: "-0.5px"
          };
        },
        confirmationThankYouMail: function confirmationThankYouMail() {
          return {
            color: "#282C25",
            fontSize: {
              base: 18,
              lg: 22
            },
            fontWeight: "500",
            fontFamily: "S52-Bold",
            letterSpacing: "-0.5px"
          };
        },
        confirmationThankYouDetailTitle: function confirmationThankYouDetailTitle() {
          return {
            color: "#494949",
            fontSize: {
              base: 18
            },
            fontFamily: "S52-Light",
            letterSpacing: {
              base: "-0.5px",
              lg: "-2px"
            }
          };
        },
        confirmationHowToText: function confirmationHowToText() {
          return {
            fontSize: {
              base: 12,
              lg: 14
            },
            color: "#494949"
          };
        },
        confirmationMarketingTitle: function confirmationMarketingTitle() {
          return {
            color: "confirmationPrimary",
            fontWeight: 400,
            fontSize: {
              base: 12,
              lg: 14
            }
          };
        },
        confirmationMarketingSubtitle: function confirmationMarketingSubtitle() {
          return {
            color: "confirmationAccent",
            fontWeight: "300",
            fontSize: 12
          };
        },
        confirmationOrderDetailsTitle: function confirmationOrderDetailsTitle() {
          return {
            color: "confirmationPrimary"
          };
        },
        confirmationOrderTotalItem: function confirmationOrderTotalItem() {
          return {
            fontFamily: "S52-Light",
            fontSize: {
              base: 19,
              lg: 22
            },
            letterSpacing: "-0.5px"
          };
        },
        confirmationOrderTotal: function confirmationOrderTotal() {
          return {
            fontFamily: "S52-Bold",
            fontSize: {
              base: 23,
              lg: 27
            },
            letterSpacing: {
              base: "-0.5px",
              lg: "-1px"
            }
          };
        },
        confirmationPaymentDetailsTitle: function confirmationPaymentDetailsTitle() {
          return {
            fontFamily: "S52-Regular",
            fontSize: {
              base: 21,
              lg: 24
            },
            letterSpacing: "-0.5px",
            color: "confirmationPrimary"
          };
        },
        confirmationOrderNumber: function confirmationOrderNumber() {
          return {
            fontSize: {
              base: 18,
              lg: 20
            },
            fontFamily: "S52-Regular",
            letterSpacing: "-0.5px"
          };
        },
        confirmationSpecialInstructionTitle: function confirmationSpecialInstructionTitle() {
          return {
            fontFamily: "S52-Bold",
            fontSize: {
              base: 18,
              lg: 22
            },
            letterSpacing: "-0.5px"
          };
        },
        confirmationSpecialInstructionSubTitle: function confirmationSpecialInstructionSubTitle() {
          return {
            fontFamily: "S52-Light",
            fontSize: {
              base: 18,
              lg: 22
            },
            letterSpacing: "-0.5px"
          };
        },
        confirmationCardChargeInfo: function confirmationCardChargeInfo() {
          return {
            fontFamily: "S52-Light",
            fontSize: {
              base: 18,
              lg: 22
            },
            letterSpacing: "-0.5px"
          };
        },
        confirmationChangesHeader: function confirmationChangesHeader() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        cartItemMenuPropertyName: {
          color: "#989182"
        },
        confirmationSvgCenteredText: function confirmationSvgCenteredText() {
          return {
            pb: {
              base: "1px",
              lg: "2px"
            }
          };
        },
        //OC AddressAndTime variants start
        confirmationPickupRestaurantTitle: function confirmationPickupRestaurantTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationPickupDateTimeTitle: function confirmationPickupDateTimeTitle() {
          return {
            fontWeight: "300",
            _ios: {
              py: 0
            },
            _android: {
              py: 0
            }
          };
        },
        confirmationDeliveryAddressTitle: function confirmationDeliveryAddressTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryRestaurantTitle: function confirmationDeliveryRestaurantTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryDateTimeTitle: function confirmationDeliveryDateTimeTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryGuestsTitle: function confirmationDeliveryGuestsTitle() {
          return {
            fontWeight: "300"
          };
        },
        //OC AddressAndTime variants end
        orderTrackingCallHelpText: {
          fontSize: "sm",
          fontWeight: 400,
          lineHeight: 5
        },
        orderStatusTrackingTitle: function orderStatusTrackingTitle() {
          return {
            color: "primary.100",
            fontWeight: 400,
            fontSize: "xl",
            lineHeight: 6
          };
        },
        orderStatusTitle: function orderStatusTitle() {
          return {
            fontSize: "sm",
            fontWeight: 400,
            lineHeight: 6,
            color: "orderStatusText"
          };
        },
        orderStatusSubText: function orderStatusSubText() {
          return {
            fontSize: "xs",
            fontWeight: 300,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        orderStatusTime: function orderStatusTime() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        orderStatusPayNowButtonText: function orderStatusPayNowButtonText() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "white"
          };
        },
        orderStatusCurbsideCheckInButtonPrimary: function orderStatusCurbsideCheckInButtonPrimary() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInPrimary"
          };
        },
        orderStatusCurbsideCheckInButtonSecondary: function orderStatusCurbsideCheckInButtonSecondary() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInSecondary"
          };
        },
        orderStatusDeatilsTitle: function orderStatusDeatilsTitle() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "#4D2C42",
            marginBottom: 3.5
          };
        },
        otCurbsideVehicleDetailsTitle: function otCurbsideVehicleDetailsTitle() {
          return {
            fontSize: "xs",
            lineHeight: 3,
            fontWeight: 300,
            color: "#606060",
            marginBottom: 1
          };
        },
        otCurbsideVehicleDetails: function otCurbsideVehicleDetails() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            fontWeight: 400,
            textTransform: "capitalize"
          };
        },
        refreshButtonText: function refreshButtonText() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "refreshButtonColor"
          };
        },
        autoRefreshText: function autoRefreshText() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "refreshButtonColor"
          };
        },
        orderTrackingLocationTimeSectionText: {
          ml: 2,
          fontSize: "sm",
          lineHeight: 6,
          fontWeight: 400
        },
        waitlistLocationName: {
          fontSize: 14,
          fontWeight: 400,
          color: "#303030"
        },
        waitlistLocationShare: {
          fontSize: 12,
          fontWeight: 400,
          color: "#B31900",
          textTransform: "uppercase"
        },
        waitlistBannerText: {
          fontSize: 14,
          fontWeight: 300,
          color: "white",
          pl: 8
        },
        waitlistTableHeaderText: {
          fontSize: {
            base: 10,
            md: 12,
            lg: 14
          },
          color: "#303030",
          fontWeight: 400,
          py: 4,
          textAlign: "center"
        },
        waitlistTableText: {
          fontSize: {
            base: 12,
            md: 12,
            lg: 14
          },
          color: "#303030",
          fontWeight: 300,
          py: 4,
          textAlign: "center"
        },
        waitlistTableNotUserName: {
          style: {
            color: "#fff0",
            textShadowColor: "rgba(0,0,0,1)",
            textShadowOffset: {
              width: 0,
              height: 0
            },
            textShadowRadius: 10
          }
        },
        refreshWaitlist: {
          fontWeight: 300
        },
        waitlistDisclaimer: {
          fontWeight: 300
        },
        waitlistOrder: {
          color: "#73994A",
          textTransform: "uppercase",
          fontWeight: 500,
          fontSize: 12
        },
        waitlistFooterHowItWorks: {
          fontWeight: 400,
          color: "secondary.300",
          fontSize: 14
        },
        myLocationsLoginText: {
          fontWeight: 700,
          fontSize: 18,
          color: "secondary.300",
          textTransform: "uppercase"
        },
        orderStatusTimeMessage: function orderStatusTimeMessage() {
          return {
            marginTop: 2,
            fontSize: "xs",
            fontWeight: 400,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        checkText: function checkText() {
          return {
            fontSize: "xs",
            fontWeight: 300,
            color: "checkText"
          };
        },
        checkAmount: function checkAmount() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "checkText"
          };
        },
        curbsideCheckInAvailableText: function curbsideCheckInAvailableText() {
          return {
            fontSize: "sm",
            lineHeight: 5,
            fontWeight: 300,
            textAlign: "center",
            color: "curbsideCheckInAvailable"
          };
        },
        // new
        deliveryErrorText: function deliveryErrorText() {
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            color: "#721C24",
            fontWeight: 300,
            lineHeight: 4
          };
        },
        menuItemInfoCalorie: function menuItemInfoCalorie() {
          return {
            _web: {
              fontSize: {
                base: "14px",
                md: "14px"
              }
            },
            fontSize: {
              base: 3,
              md: 3
            },
            fontWeight: "400"
          };
        },
        skuSelectorItemPriceText: function skuSelectorItemPriceText() {
          return {
            fontWeight: 500,
            fontSize: {
              base: 14,
              md: 16
            }
          };
        },
        skuSelectorItemName: function skuSelectorItemName() {
          return {
            fontWeight: 400,
            fontSize: {
              base: 14,
              md: 18
            }
          };
        },
        mobileAuthHeaderText: function mobileAuthHeaderText() {
          return {
            fontWeight: 300,
            fontSize: 24,
            color: "#505050"
          };
        },
        mobileOrderDetailsHeader: function mobileOrderDetailsHeader() {
          return {
            fontWeight: 400,
            fontSize: 18
          };
        },
        mobileOrderDetailsStatic: function mobileOrderDetailsStatic() {
          return {
            fontWeight: 300,
            fontSize: 12
          };
        },
        mobileOrderDetailsInput: function mobileOrderDetailsInput() {
          return {
            fontWeight: 400,
            fontSize: 16
          };
        },
        temperatureSelectLabel: function temperatureSelectLabel() {
          return {
            color: "#B0B0B0",
            fontSize: "lg",
            fontFamily: "headingSecondary"
          };
        },
        sectionHeaderText: function sectionHeaderText() {
          return {
            color: "#303030",
            fontWeight: 600
          };
        },
        subSectionHeaderText: function subSectionHeaderText() {
          return {
            color: "#303030",
            fontWeight: 600
          };
        },
        notificationsPopupText: function notificationsPopupText() {
          return {
            color: "#303030",
            fontWeight: 600
          };
        },

        /* Restaurant Details Start */
        //Restaurant Info
        restaurantDetails_RestInfo_AddToFavoritesText: function restaurantDetails_RestInfo_AddToFavoritesText() {
          return {
            alignItems: "center",
            color: "restaurantInfoAddToFavouritiesTextColor",
            fontSize: {
              base: "14px",
              lg: "16px"
            },
            ml: "3",
            h: "20px",
            //font specific styles
            pt: "1px"
          };
        },
        restaurantDetails_RestInfo_TitleText: function restaurantDetails_RestInfo_TitleText() {
          return {
            fontWeight: "600",
            fontFamily: "S52-Bold",
            color: "restDetailsRestInfoTitleColor",
            mb: {
              base: "2",
              lg: "0"
            },
            textTransform: "uppercase",
            fontSize: {
              base: "24px",
              lg: "42px"
            },
            textAlign: {
              base: "center",
              lg: "normal"
            }
          };
        },
        restaurantDetails_RestInfo_OpensText: function restaurantDetails_RestInfo_OpensText() {
          return {
            fontWeight: "500",
            fontSize: {
              base: "xs",
              lg: "sm"
            },
            color: "restDetailsRestInfoTitleColor"
          };
        },
        restaurantDetails_RestInfo_DateText: function restaurantDetails_RestInfo_DateText() {
          return {
            fontWeight: "500",
            fontSize: {
              base: "xs",
              lg: "sm"
            },
            color: "restDetailsRestInfoTitleColor",
            textTransform: "uppercase"
          };
        },
        restaurantDetails_RestInfo_AddressText: function restaurantDetails_RestInfo_AddressText() {
          return {
            fontWeight: 300,
            lineHeight: 6,
            px: 4,
            fontSize: {
              base: 14,
              lg: 16
            },
            _web: {
              lineHeight: {
                base: 5,
                lg: 7
              },
              my: 4,
              px: 0,
              style: {
                "text-underline-offset": "3px"
              }
            },
            textAlign: {
              base: "center",
              lg: "flex-start"
            },
            w: "100%",
            _ios: {
              flex: 1
            },
            _android: {
              flex: 1
            },
            textDecoration: "underline",
            textDecorationColor: "primary.100",
            color: "primary.100"
          };
        },
        restaurantDetails_RestInfo_PhoneNumberText: function restaurantDetails_RestInfo_PhoneNumberText(_ref29) {
          var customMarginHorizontal = _ref29.customMarginHorizontal;
          return {
            _ios: {
              mx: customMarginHorizontal || 0
            },
            _android: {
              mx: customMarginHorizontal || 0
            },
            marginLeft: 1,
            fontWeight: 300,
            fontSize: {
              base: 14,
              lg: 18
            },
            color: "primary.100"
          };
        },
        restaurantDetails_RestInfo_DistanceText: function restaurantDetails_RestInfo_DistanceText() {
          return {
            fontWeight: "300",
            fontSize: "14px",
            color: "#C16436"
          };
        },
        restaurantDetails_RestInfo_GetDirectionsText: function restaurantDetails_RestInfo_GetDirectionsText() {
          return {
            color: "amenitiesActionButtonsColor",
            fontSize: {
              base: "14px",
              lg: "16px"
            }
          };
        },
        //Restaurant Waitlist
        restaurantDetails_RestWaitlist_WaitlistAvailabilityDescText: function restaurantDetails_RestWaitlist_WaitlistAvailabilityDescText() {
          return {
            mb: "6",
            fontSize: {
              base: 14,
              lg: 16
            },
            fontWeight: 300,
            px: 6,
            maxW: {
              lg: "350",
              xl: "400"
            },
            textAlign: "center",
            mx: "auto",
            color: {
              base: "#404040",
              lg: "#303030"
            }
          };
        },
        restaurantDetails_RestWaitlist_WaitlistAvailabilityRestName: function restaurantDetails_RestWaitlist_WaitlistAvailabilityRestName() {
          return {
            color: "#404040"
          };
        },
        restaurantDetails_RestWaitlist_WaitlistAvailabilityPartySize: function restaurantDetails_RestWaitlist_WaitlistAvailabilityPartySize() {
          return {
            fontWeight: "300",
            fontSize: 14,
            color: "#404040"
          };
        },
        //Restaurant CurrentStatus and Waitlist
        restaurantDetails_RestWaitlist_CurrentStatusText: function restaurantDetails_RestWaitlist_CurrentStatusText() {
          return {
            fontWeight: "300",
            color: "#606060",
            fontSize: {
              base: "14",
              lg: "16"
            }
          };
        },
        restaurantDetails_RestWaitlist_AvailabilityText: function restaurantDetails_RestWaitlist_AvailabilityText() {
          return {
            _ios: {
              marginLeft: 4
            },
            _android: {
              marginLeft: 4
            },
            fontSize: "14px",
            fontWeight: "300",
            color: "restaurantWaitlistTextColor",
            maxWidth: {
              base: 40,
              lg: "none"
            },
            lineHeight: 6
          };
        },
        restaurantDetails_RestWaitlist_JoinWaitlistText: function restaurantDetails_RestWaitlist_JoinWaitlistText(_ref30) {
          var disabled = _ref30.disabled;
          return {
            color: "white",
            fontSize: "20px",
            fontFamily: "S52-Regular",
            fontWeight: "400",
            _android: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            },
            _ios: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            },
            _web: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            }
          };
        },
        restaurantDetails_RestWaitlist_EstWaitTimeText: function restaurantDetails_RestWaitlist_EstWaitTimeText() {
          return {
            _android: {
              marginTop: 2.5
            },
            _ios: {
              marginTop: 2.5
            },
            lineHeight: 3,
            fontWeight: "300",
            color: "restaurantWaitlistTextColor",
            fontSize: "11",
            textAlign: "center",
            maxWidth: 40,
            _web: {
              maxWidth: 32,
              fontSize: "12px",
              marginTop: {
                base: 2,
                lg: 0
              }
            }
          };
        },
        //Restaurant Timings
        restaurantDetails_RestTimings_TitleText: function restaurantDetails_RestTimings_TitleText() {
          return {
            fontFamily: "S52-Bold",
            fontSize: {
              base: 24,
              lg: 24
            },
            color: "restaurantHoursTextColor"
          };
        },
        restaurantDetails_RestTimings_SpecialDayTitleText: function restaurantDetails_RestTimings_SpecialDayTitleText() {
          return {
            marginBottom: 3,
            color: "restaurantSpecialDayHeadingTextColor",
            fontSize: "16px",
            textAlign: "center",
            px: "3"
          };
        },
        restaurantDetails_RestTimings_SpecialDayDescText: function restaurantDetails_RestTimings_SpecialDayDescText() {
          return {
            fontSize: "14px",
            fontWeight: "300",
            lineHeight: 20,
            color: "restaurantSpecialDayBodyTextColor",
            textAlign: "center"
          };
        },
        restaurantDetails_RestTimings_WeekDayIconText: function restaurantDetails_RestTimings_WeekDayIconText() {
          return {
            lineHeight: 5,
            fontSize: "12px",
            textTransform: "capitalize",
            _ios: {
              paddingTop: 0.5,
              paddingLeft: 0.5
            }
          };
        },
        restaurantDetails_RestTimings_FullDayTitleText: function restaurantDetails_RestTimings_FullDayTitleText() {
          return {
            fontSize: {
              base: "14",
              lg: "16"
            },
            lineHeight: 4,
            color: "restaurantTimingsHeadingTextColor",
            maxWidth: "50%",
            textTransform: "capitalize",
            pr: 1
          };
        },
        restaurantDetails_RestTimings_HoursTitleText: function restaurantDetails_RestTimings_HoursTitleText() {
          return {
            fontSize: {
              base: "14",
              lg: "16"
            },
            lineHeight: 4,
            color: "restaurantTimingsHeadingTextColor",
            maxWidth: "50%",
            pl: 1
          };
        },
        restaurantDetails_RestTimings_FullDayItemText: function restaurantDetails_RestTimings_FullDayItemText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "300",
            maxWidth: "50%",
            pr: 1
          };
        },
        restaurantDetails_RestTimings_HoursItemText: function restaurantDetails_RestTimings_HoursItemText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "300",
            maxWidth: "50%",
            pl: 1
          };
        },
        restaurantDetails_RestTimings_MessageText: function restaurantDetails_RestTimings_MessageText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "13",
              lg: "14"
            },
            fontWeight: "100",
            _ios: {
              lineHeight: 5,
              fontSize: 12
            },
            _android: {
              lineHeight: 5,
              fontSize: 12
            }
          };
        },
        restaurantDetails_RestTimings_SpecialHoursText: function restaurantDetails_RestTimings_SpecialHoursText() {
          return {
            fontWeight: 300,
            fontSize: 12,
            color: "#404040",
            fontStyle: "italic"
          };
        },
        //Restaurant About
        restaurantDetails_RestAbout_TitleText: function restaurantDetails_RestAbout_TitleText() {
          return {
            fontFamily: "S52-Bold",
            color: "restaurantAboutSectionHeadingTextColor",
            marginBottom: 4,
            fontSize: 24,
            lineHeight: 6,
            display: {
              base: "flex",
              lg: "none"
            }
          };
        },
        restaurantDetails_RestAbout_DescText: function restaurantDetails_RestAbout_DescText() {
          return {
            color: "restaurantAboutSectionBodyTextColor",
            paddingBottom: 4,
            fontSize: {
              base: 14,
              lg: 16
            },
            fontWeight: "200",
            lineHeight: 5
          };
        },
        //Restaurant Action Buttons
        restaurantDetails_ActionButtons_CTAButtonLabelText: function restaurantDetails_ActionButtons_CTAButtonLabelText() {
          return {
            fontSize: "20px",
            fontFamily: "S52-Regular",
            color: "orderFromHereButtonTextColor",
            textAlign: "center",
            textTransform: "uppercase",
            _web: {
              textTransform: "uppercase"
            }
          };
        },
        //Restaurant Amenities
        restaurantDetails_Amenities_TitleText: function restaurantDetails_Amenities_TitleText() {
          return {
            fontFamily: "S52-Bold",
            paddingBottom: 4,
            fontSize: {
              base: "24px",
              lg: "24px"
            },
            color: "amenitiesHeadingColor",
            display: {
              base: "flex"
            }
          };
        },
        restaurantDetails_Amenities_IconName: {
          fontWeight: 300,
          fontSize: {
            base: "14",
            lg: "16"
          },
          color: {
            base: "#303030",
            lg: "#494949"
          }
        },
        restaurantDetails_Amenities_Description: {
          fontSize: {
            base: 12,
            lg: 14
          },
          fontWeight: "300",
          color: "#606060"
        },
        restaurantDetails_Amenities_Title: {
          fontSize: {
            base: 14,
            lg: 16
          },
          mb: 1,
          color: "#303030"
        },
        //Restaurant Holiday Msg
        restaurantDetails_HolidayMsg_Text: {
          textAlign: "center",
          fontSize: {
            base: "14px"
          },
          color: "#8F2B6D",
          fontWeight: "400",
          maxW: {
            base: "250px",
            md: "350",
            lg: "100%"
          },
          mx: "auto",
          lineHeight: 5
        },
        restDetails_TextMapper_Title: function restDetails_TextMapper_Title() {
          return {
            fontWeight: 400,
            fontSize: 28,
            mb: 4,
            color: "white",
            textAlign: "left"
          };
        },
        restDetails_TextMapper_Description: function restDetails_TextMapper_Description() {
          return {
            fontWeight: 300,
            fontSize: 18,
            color: "white",
            textAlign: "left"
          };
        },
        //Restaurant Order Button
        restaurantDetails_OrderButton_LabelText: function restaurantDetails_OrderButton_LabelText() {
          return {
            _android: {
              paddingY: 5,
              textTransform: "uppercase"
            },
            _ios: {
              paddingY: 5,
              textTransform: "uppercase"
            },
            fontSize: "20px",
            fontFamily: "S52-Regular",
            color: "orderFromHereButtonTextColor",
            textAlign: "center",
            textTransform: {
              base: "uppercase",
              lg: "uppercase"
            }
          };
        },
        restaurantDetails_RestTimings_WeekDay: function restaurantDetails_RestTimings_WeekDay() {
          return {
            color: {
              base: "#303030",
              lg: "restaurantTimingWeekDayTextColor"
            },
            fontSize: {
              base: "12",
              lg: "12"
            },
            position: "absolute"
          };
        },
        locationTitleHeader: function locationTitleHeader() {
          return {
            fontWeight: 500,
            fontSize: 20,
            color: "preferredLocationHeaderTextColor"
          };
        },
        waitlist_leave_the_line_text: function waitlist_leave_the_line_text() {
          return {
            fontSize: 16,
            fontWeight: 300,
            color: "#606060"
          };
        },
        waitlist_leave_the_line_link: function waitlist_leave_the_line_link() {
          return {
            fontSize: 16,
            fontWeight: 400,
            color: "#A2402A"
          };
        },
        reservationConfirmationText: {
          fontWeight: 200
        },
        //LocationSearch Start
        locationSearchHeading: function locationSearchHeading() {
          return {
            fontWeight: 600,
            fontSize: 20,
            fontFamily: "heading",
            color: "locationSearchTitle"
          };
        },
        recentLocationsText: function recentLocationsText() {
          return {
            fontSize: {
              base: 17,
              md: 20
            },
            fontWeight: 500,
            lineHeight: 5
          };
        },
        orderSettingsQuantityText: function orderSettingsQuantityText() {
          return {
            fontSize: "md",
            py: 2,
            px: 5
          };
        },
        sliderTitleText: function sliderTitleText() {
          return {
            fontSize: {
              base: 14
            },
            fontWeight: {
              base: 500
            }
          };
        },
        reorderButtonText: function reorderButtonText() {
          return {
            fontWeight: 500
          };
        },
        desktopBreadcrumbVariant: function desktopBreadcrumbVariant() {
          return {
            fontSize: "sm",
            fontWeight: "500",
            lineHeight: 4,
            letterSpacing: "xs",
            textTransform: "uppercase",
            p: "0",
            m: "0"
          };
        },
        desktopLastBreadcrumbVariant: function desktopLastBreadcrumbVariant() {
          return {
            fontSize: "sm",
            fontWeight: "500",
            lineHeight: 4,
            letterSpacing: "xs",
            textTransform: "uppercase",
            p: "0",
            m: "0"
          };
        },
        numberOfCartItems: function numberOfCartItems() {
          return {
            fontWeight: 500
          };
        },
        restTimingsSplMsg: function restTimingsSplMsg() {
          return {
            fontWeight: 300
          };
        },
        currentlyUnavailableText: function currentlyUnavailableText() {
          return {
            color: "primary.100",
            fontWeight: {
              base: 500
            }
          };
        },
        menuCartHeaderTexLineHeightForApp: {
          lineHeight: 5
        },
        legalDisclaimerText: {
          lineHeight: 5
        },
        menuDetailDesciptionMobile: function menuDetailDesciptionMobile() {
          return {
            fontFamily: "Barlow-Regular",
            color: "#989182",
            fontSize: 14
          };
        },
        nutritionalInfoBottomSheetAllergenInfo: function nutritionalInfoBottomSheetAllergenInfo() {
          return {
            color: "themeGrey",
            fontWeight: "200",
            fontSize: "xs"
          };
        },
        nutritionalInfoBottomSheetQuestion: function nutritionalInfoBottomSheetQuestion() {
          return {
            fontWeight: "300",
            color: "themeGrey",
            fontSize: "sm"
          };
        },
        reservationInfoValue: function reservationInfoValue() {
          return {
            fontWeight: 500,
            fontSize: 12,
            color: "#70695C",
            lineHeight: 5
          };
        },
        reservationInfoKey: function reservationInfoKey() {
          return {
            fontWeight: 400,
            fontSize: 11,
            color: "#989182",
            lineHeight: 5
          };
        }
      }
    },
    HStack: {
      variants: {
        /* RESERVATION */
        joinWaitlist_Header_Container: function joinWaitlist_Header_Container() {
          return {
            _ios: {
              height: 20
            },
            _android: {
              height: 20
            },
            justifyContent: "center",
            alignItems: "center",
            w: "100%",
            borderBottomWidth: 1,
            borderBottomColor: "#FFFFFF",
            bg: "#FFFFFF"
          };
        },
        reservationConfirmationDateTimeSizeHStack: {
          justifyContent: "flex-start",
          alignItems: "flex-start",
          mr: 1,
          flex: 1
        },
        reservationConfirmationDateTimeSizeContainer: {
          pt: 4,
          px: 3,
          justifyContent: "space-between"
        },
        reservationLookUpSuccessHStack: function reservationLookUpSuccessHStack(_ref31) {
          var isError = _ref31.isError;
          return {
            justifyContent: "center",
            space: 2,
            alignItems: "center",
            py: 2,
            my: 2,
            bg: isError ? "#DF450530" : "#F3EDDF",
            maxW: {
              md: "340px"
            },
            w: "100%",
            borderRadius: 0
          };
        },
        reservationLocationCardHStack: {
          my: 4,
          mx: 5,
          alignItems: "center",
          px: 4,
          py: 3,
          borderRadius: 0,
          shadow: 10,
          bg: "white"
        },
        reservationLocationItemHStack: {
          justifyContent: "space-between",
          alignItems: "flex-start",
          borderBottomWidth: 1,
          borderTopWidth: {
            base: 0,
            md: 1
          },
          borderLeftWidth: {
            base: 0,
            md: 1
          },
          borderRightWidth: {
            base: 0,
            md: 1
          },
          borderRadius: 0,
          borderColor: "#DEDEDE",
          py: {
            base: 6,
            md: 4
          },
          px: {
            base: 0,
            md: 4
          },
          m: {
            base: 0,
            md: 4
          }
        },
        reservationProfileCardHStack: {
          my: 4,
          _ios: {
            paddingX: 4
          },
          _android: {
            paddingX: 4
          },
          borderRadius: 0,
          shadow: 10,
          bg: {
            base: "white",
            md: "transparent"
          }
        },
        reservationProfileCardLoggedInHStack: {
          alignItems: "center",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          _web: {
            justifyContent: "space-between",
            w: "100%",
            px: 4
          },
          my: 3,
          bg: "white"
        },

        /* RESERVATION */
        //JWC START
        jwcFooterBlock: {
          py: 2,
          bg: "white",
          borderRadius: 12,
          borderColor: "#C6C6C6",
          borderWidth: 1
        },
        jwcLocationHeaderBlock: {
          py: 5,
          px: 6,
          borderRadius: 12,
          bg: "white",
          borderColor: "transparent",
          borderWidth: 1
        },
        //JWC END
        header: {
          bg: "themeTextColor"
        },
        checkoutBtn: {
          alignItems: "center",
          justifyContent: "space-around",
          _web: {
            height: "60px"
          },
          py: 3,
          px: 5,
          rounded: 0
        },
        scheduledOrderForm: {
          alignItems: "center",
          width: "100%",
          rounded: 6,
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          borderColor: "themeTextFieldBoundary",
          pl: 3,
          mb: 4
        },
        menuDetailIsUnavailable: function menuDetailIsUnavailable(_ref32) {
          var isSelected = _ref32.isSelected;
          return {
            bg: "#E5E5E5",
            borderColor: "themeSectionSeparator",
            shadow: 5,
            overflow: "hidden"
          };
        },
        listItemBox: {
          borderRadius: 0
        },
        //Restaurant Details
        restaurantDetails_Index_RestAbout_HStack: {
          mt: "10",
          space: {
            lg: "md",
            xl: "2xl"
          }
        },
        restaurantDetails_Amenities_AmenitiesIcons_HStack: {
          alignItems: "center"
        },
        restaurantDetails_CurrentStatus_Icon_HStack: {
          alignItems: "center",
          justifyContent: "center",
          _web: {
            justifyContent: {
              base: "center",
              lg: "normal"
            }
          }
        },
        restaurantDetails_RestInfo_AddToFavourites_HStack: {
          alignItems: "center",
          mb: "6"
        },
        restaurantDetails_RestInfo_StarIcon_HStack: {
          alignItems: "center"
        },
        restaurantDetails_RestTime_HStack: {
          alignItems: "center",
          mb: "4"
        },
        restaurantDetails_RestTime_HoursLegend_HStack: {
          mr: "0",
          ml: "auto",
          justifyContent: "center"
        },
        restaurantDetails_RestTimings_WeekDaysIcon_HStack: {
          mb: 9,
          space: 1,
          justifyContent: "space-between"
        },
        restaurantDetails_RestTimings_SelectedDay_HStack: {
          mb: 4,
          space: 1,
          justifyContent: "space-between"
        },
        restaurantDetails_RestTimings_List_HStack: {
          marginBottom: 3,
          justifyContent: "space-between"
        },
        restaurantDetails_Waitlist_Party_HStack: {
          justifyContent: "center",
          alignItems: "center",
          mb: {
            base: 5
          }
        },
        restaurantDetails_Waitlist_Button_HStack: {
          justifyContent: "center"
        },
        //Order Tracking
        orderTrackingPayNowButtonHStack: {
          bgColor: "payNowButtonBg",
          px: 5,
          py: 3,
          borderRadius: "md",
          alignItems: "center",
          justifyContent: "space-between"
        },
        orderTrackingCallHelpHStack: {
          py: 4,
          px: 5,
          _web: {
            minHeight: "68px",
            bottom: 0
          },
          bgColor: "background.100",
          borderTopColor: "borderColorCallSection",
          borderTopWidth: 1,
          alignItems: "center",
          justifyContent: "space-between",
          mt: "auto"
        },
        borderRadiusValue: function borderRadiusValue(_ref33) {
          var radiusValue = _ref33.radiusValue,
              topRadiusValue = _ref33.topRadiusValue,
              bottomRadiusValue = _ref33.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        menuDetailArrowPosition: {
          mt: 1.5
        },
        menuDetailPropertyAccordionDescriptionTile: {
          mt: {
            base: 1.5,
            md: 1
          }
        }
      }
    },
    Flex: {
      variants: {
        orderConfirmationflex: {
          _web: {
            flexDirection: {
              base: "column-reverse",
              lg: "row"
            }
          },
          alignItems: "flex-start"
        }
      }
    },
    Image: {
      variants: {
        cartItemImage: {
          _web: {
            height: {
              base: "71px"
            },
            width: {
              base: "100px"
            }
          },
          height: 70,
          width: 100
        },
        menu_item_card_vertical_image_border_radius: 0,
        //Restaurant Details
        restaurantDetails_RestInfo_Mob_Image: {
          h: "98px",
          w: "98px",
          resizeMode: "cover",
          _web: {
            h: {
              base: "97px",
              lg: "210px"
            },
            w: {
              base: "97px",
              lg: "220px"
            }
          }
        },
        restaurantDetails_RestInfo_ImageLg: {
          h: "98px",
          w: "98px",
          resizeMode: "cover",
          _web: {
            h: {
              base: "97px",
              lg: "89px"
            },
            w: {
              base: "97px",
              lg: "94px"
            }
          }
        },
        restaurantDetails_RestInfo_FavoriteIconLg: {
          height: "16px",
          width: "16px"
        },
        restaurantDetails_RestInfo_BrandIcon: {
          borderRadius: 10
        },
        restaurantDetails_RestInfo_BrandIconLg: {
          borderRadius: 10
        },
        //Edit Waitlist
        editWaitlist_LocationHeader_Icon: {
          _web: {
            width: 4,
            height: 5
          }
        },
        rd_spl_hours_legend: {
          width: "11px",
          height: "11px",
          mr: "1"
        },
        rd_spl_hours_icon: {
          width: "11px",
          height: "11px",
          top: 0,
          right: 0,
          position: "absolute"
        },
        //location search page
        location_search_exclamation_icon: {
          display: "none"
        },
        borderRadiusValue: function borderRadiusValue(_ref34) {
          var radiusValue = _ref34.radiusValue,
              topRadiusValue = _ref34.topRadiusValue,
              bottomRadiusValue = _ref34.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        favorite_pin_fill_brand_icon: function favorite_pin_fill_brand_icon(_ref35) {
          var active = _ref35.active;
          return {
            height: active ? 4 : 3,
            width: active ? 4 : 3
          };
        },
        //cart overlay
        cart_overlay_pickup_date_brand_icon: {
          _web: {
            height: 5,
            width: 5
          },
          height: 20,
          width: 20,
          mr: 0
        },
        cart_overlay_pickup_time_brand_icon: {
          height: 20,
          width: 20,
          _web: {
            height: 5,
            width: 5
          },
          mr: 0
        }
      }
    },
    Input: {
      baseStyle: {
        rounded: 0,
        fontFamily: "Barlow-Regular"
      },
      variants: {
        menuSearchInputContainer: {
          borderRadius: 0
        },
        borderRadiusValue: function borderRadiusValue(_ref36) {
          var radiusValue = _ref36.radiusValue,
              topRadiusValue = _ref36.topRadiusValue,
              bottomRadiusValue = _ref36.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        }
      }
    },
    VStack: {
      variants: {
        jwcWaitTimeBlock: {
          p: 3,
          px: 6,
          bg: "white",
          borderRadius: 12,
          borderColor: "#C6C6C6",
          borderWidth: 1
        },
        addToCartContainer: {
          w: {
            base: "76px",
            md: "120px"
          }
        },
        indicatorsContainer: {
          flex: 1
        },
        //Restaurant Details
        restaurantDetails_Index_RestInfo_VStack: {
          space: "xs"
        },
        restaurantDetails_Index_RestAbout_VStack: {
          mx: {
            lg: "60px"
          }
        },
        restaurantDetails_Index_RestAbout_InnerVStack: {
          flex: {
            lg: 4,
            xl: 1
          },
          space: "2xs"
        },
        restaurantDetails_Index_BrandFooter_VStack: {
          overflowX: "hidden"
        },
        restaurantDetails_ActionButtons_VStack: {
          space: "md"
        },
        restaurantDetails_RestInfo_StarIcon_VStack: {
          space: 4,
          justifyContent: "center",
          flex: 1,
          direction: "column-reverse"
        },
        //order tracking
        orderTrackingRefreshButtonVStack: {
          borderColor: "refreshButtonColor",
          borderWidth: 1,
          borderRadius: 6,
          py: 2,
          px: 1,
          space: 1.5,
          alignItems: "center",
          bg: "refreshButtonBg"
        },
        orderTrackingAutoRefreshVStack: {
          borderColor: "orderStatusSectionBorderColor",
          borderWidth: 1,
          borderRadius: 6,
          py: 2.5,
          px: 4,
          space: 1.5,
          alignItems: "center",
          bg: "refreshButtonBg"
        },
        nutritionalInfoVStack: {
          mt: {
            base: 2,
            md: 3
          },
          mb: "2",
          alignItems: "flex-start",
          width: "100%",
          _web: {
            width: {
              base: "100%",
              md: "100%",
              lg: "966px"
            }
          }
        },
        vstackBorderBottomRadius: {
          borderBottomRadius: 0
        }
      }
    },
    Box: {
      variants: {
        /*RESERVATION*/
        reservationConfirmationDateTimeSizeBox: {
          flex: 1,
          alignItems: "flex-start"
        },
        reservationConfirmationBoxBorderRadius: {
          borderRadius: 0
        },
        reservationConfirmationDetailsBox: {
          borderRadius: 0,
          my: {
            base: 6,
            md: 0
          },
          py: {
            base: 5,
            md: 6
          },
          borderTopWidth: 1,
          borderColor: "#0000001a"
        },
        reservationProfileInputBox: {
          pl: {
            base: 4,
            md: 5
          },
          pr: 4,
          bg: "white",
          _web: {
            pb: 9
          },
          borderRadius: 0
        },
        reservationProfileContactDetailsBox: {
          py: 3,
          flex: 1,
          my: 3
        },
        reviewReservationsContainerBox: {
          mt: 8,
          alignItems: "center",
          px: 4,
          _web: {
            bg: {
              base: "reservationBg",
              md: "myReservationsBoxBg"
            },
            maxW: {
              md: "680px"
            },
            py: 8,
            mt: {
              base: 8,
              md: 16
            },
            px: {
              base: 5,
              md: 24
            },
            mb: {
              base: 8,
              md: 16
            }
          }
        },
        reservationDropdownRadius: 0,
        reservationLocationDropdownSelectBox: {
          borderWidth: 1,
          borderRadius: 0,
          width: {
            base: "100%",
            md: "400px"
          },
          borderColor: "#DEDEDE"
        },
        reservationLocationDropdownBox: {
          bg: "#F9F7F0",
          py: 4,
          justifyContent: "center",
          px: {
            base: 6,
            md: 16
          }
        },
        reservationAvailableTimeSlotBtnBox: {
          _web: {
            width: 24,
            py: 2
          },
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "row",
          borderRadius: 0,
          _ios: {
            width: 24,
            height: 10
          },
          _android: {
            width: 24,
            height: 10
          }
        },
        reservationAvailableTimeSlotsBox: {
          borderWidth: 1,
          _ios: {
            py: 3
          },
          _android: {
            py: 3
          },
          _web: {
            py: 4,
            px: 3
          },
          w: "100%",
          mt: 4,
          borderRadius: 0,
          bg: "white"
        },
        reservationTabsBtn: function reservationTabsBtn(_ref37) {
          var isActive = _ref37.isActive;
          return {
            minW: {
              base: "167px",
              md: "191px"
            },
            px: 1,
            h: {
              base: "38px",
              md: "42px"
            },
            bg: isActive ? "reservationBg" : "primary.100"
          };
        },

        /*RESERVATION*/
        rd_spl_hours_icon: {
          width: 11,
          height: 11,
          top: 0,
          right: 0,
          position: "absolute"
        },
        rd_spl_hours_legend: {
          width: 11,
          height: 11,
          mr: 1
        },
        indicatorBanner: {
          fontFamily: "Barlow-Medium"
        },
        jwcHowItWorksBox: {
          borderBottomWidth: 1,
          borderBottomColor: {
            base: "#A2402A",
            lg: "white"
          }
        },
        checkinSuccessNote: {
          bg: "#A9AD00",
          px: 9,
          py: 6,
          borderRadius: 12,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        onboardingScreenTextContainer: {
          top: "71%"
        },
        locationDropdownRadius: 0,
        emptyCartModalRadius: 8,
        appMessagesSuccessDialogBorderRadius: 0,
        sectionHeaderBottomSpace: function sectionHeaderBottomSpace(_ref38) {
          var hasSub = _ref38.hasSub;
          return {
            mb: {
              base: hasSub && -0.5,
              md: hasSub && -1
            }
          };
        },
        HomeScreenCTAflex: {
          flexDirection: "column-reverse"
        },
        configOptionBox: {
          borderRadius: 0
        },
        configOptionBoxWithMAPPWidth: {
          borderRadius: 0,
          _ios: {
            minWidth: 72
          },
          _android: {
            minWidth: 72
          }
        },
        sliderItemBox: {
          borderRadius: {
            base: 8
          }
        },
        brandLogoMobileDimensions: function brandLogoMobileDimensions() {
          return {
            _ios: {
              height: 12,
              width: 40
            },
            _android: {
              height: 12,
              width: 40
            },
            _web: {
              height: "50px",
              width: "166px"
            }
          };
        },
        menuDetailDesciption: function menuDetailDesciption() {
          return {
            fontFamily: "Barlow-Regular",
            color: "#989182",
            _web: {
              fontSize: {
                base: "14px",
                md: "16px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            }
          };
        },
        menuCardBodyPrice: {
          bottom: 0
        },
        temperatureSlider: function temperatureSlider() {
          return {
            bg: "E9E9E9",
            _web: {
              height: {
                base: "360px"
              },
              pb: 5
            },
            height: 400,
            pb: 10
          };
        },
        categoryActiveBorder: {
          borderBottomWidth: 3
        },
        tempDescriptionBox: function tempDescriptionBox(_ref39) {
          var isChild = _ref39.isChild;
          return {
            px: {
              base: 3,
              md: isChild ? 3 : 5
            },
            py: 5,
            borderLeftRadius: 0,
            borderRightRadius: {
              base: 0,
              md: isChild ? 0 : 0
            },
            bg: "white",
            shadow: 11,
            _web: {
              width: {
                base: "177px",
                md: isChild ? "177px" : "325px"
              }
            }
          };
        },
        selectLocationDropDownBox: {
          ml: {
            base: 0,
            md: 8
          },
          mt: {
            base: 3,
            md: 0
          },
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1,
          borderRadius: 0,
          _web: {
            width: {
              base: "100%",
              md: "335px"
            }
          },
          borderColor: {
            base: "allLocationsSelectBorderColorMobile",
            md: "allLocationsSelectBorderColorDesktop"
          }
        },
        locationCard: function locationCard(_ref40) {
          var isFromLocationSearchPage = _ref40.isFromLocationSearchPage;
          return {
            borderBottomWidth: 1,
            borderWidth: {
              base: 0,
              md: 1
            },
            borderColor: "allLocationsItemBoxBorderColor",
            borderRadius: 0,
            p: {
              base: 0,
              md: 1
            },
            mt: {
              base: 0,
              md: 4
            },
            mr: {
              base: 0,
              md: isFromLocationSearchPage ? "2%" : 8
            },
            _web: {
              minWidth: {
                base: "100%",
                md: "300px"
              }
            },
            width: isFromLocationSearchPage ? "48%" : "40%",
            bg: "#ffffff"
          };
        },
        listCard: {
          borderRadius: 8,
          position: "relative",
          pt: {
            base: 3
          },
          pb: {
            base: "14px"
          },
          px: {
            base: 3
          },
          p: {
            lg: 5
          }
        },
        headerCaretIconMobile: function headerCaretIconMobile() {
          return {
            mb: 0
          };
        },
        searchItemCardContainer: function searchItemCardContainer() {
          return {
            width: "100%",
            pr: 4,
            borderBottomWidth: 1,
            borderColor: "#EAEAEA"
          };
        },
        searchModalMenuCategoryListBox: function searchModalMenuCategoryListBox(_ref41) {
          var isMobile = _ref41.isMobile;
          return {
            borderRadius: !isMobile ? 12 : 0
          };
        },
        //Restaurant Details start
        restaurantDetails_Index_Map_Box: {
          flex: 1
        },
        restaurantDetails_Index_RestInfo_Box: {
          flex: 1,
          borderBottomColor: "#D6D6D6",
          borderBottomWidth: "1px"
        },
        restaurantDetails_Index_RestInfo_InnerBox: {
          px: 8
        },
        restaurantDetails_Index_CurrentStatus_Box: function restaurantDetails_Index_CurrentStatus_Box(_ref42) {
          var hideWaitlistSection = _ref42.hideWaitlistSection;
          return {
            px: 8,
            mb: hideWaitlistSection ? 0 : 10
          };
        },
        restaurantDetails_Index_WaitList_Box: {
          position: "relative",
          h: "auto"
        },
        restaurantDetails_Index_Divider_Box: {
          px: 6
        },
        restaurantDetails_Index_Amenities_Box: {
          pt: 4
        },
        restaurantDetails_Index_RestTime_Box: {
          flex: {
            lg: 5,
            xl: 1
          }
        },
        restaurantDetails_Index_RestTime_Mob_Box: {
          position: "relative",
          h: "auto"
        },
        restaurantDetails_Index_ActionButtons_Box: {
          flex: {
            lg: 3,
            xl: 1
          },
          pr: 2
        },
        restaurantDetails_Index_Mob_OrderButton_Box: function restaurantDetails_Index_Mob_OrderButton_Box(_ref43) {
          var isSticky = _ref43.isSticky;
          return {
            py: 4,
            px: isSticky ? 4 : 0,
            backgroundColor: "#F9F7F0"
          };
        },
        restaurantDetails_Index_Mob_RestAbout_Box: {
          h: "auto"
        },
        restaurantDetails_ActionButtons_ViewMenu_Box: function restaurantDetails_ActionButtons_ViewMenu_Box(_ref44) {
          var isMobile = _ref44.isMobile,
              singleActionButton = _ref44.singleActionButton;
          return {
            px: 4,
            _web: {
              display: "grid"
            },
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
            style: {
              "grid-template-columns": "1fr",
              "column-gap": "10px"
            }
          };
        },
        restaurantDetails_ActionButtons_ViewMenu_InnerBox: {
          _web: {
            mb: {
              base: 3,
              lg: 4
            }
          }
        },
        restaurantDetails_Amenities_IconBox: {
          alignItems: "center",
          flexWrap: "wrap",
          flexDirection: "row"
        },
        restaurantDetails_Amenities_Box: {
          px: {
            base: 4,
            lg: 6
          }
        },
        restaurantDetails_CurrentStatus_Icon_Box: {
          mr: 4
        },
        restaurantDetails_CurrentStatus_Mob_Divider_Box: {
          mt: 4,
          alignItems: "center"
        },
        restaurantDetails_HolidayMsg_Box: {
          px: {
            base: 2,
            lg: 3
          },
          py: 3,
          bg: "#FFFFFF"
        },
        restaurantDetails_Map_Box: {
          height: "140px",
          position: "relative"
        },
        restaurantDetails_OrderButtonSection_Box: function restaurantDetails_OrderButtonSection_Box(_ref45) {
          var isInStack = _ref45.isInStack;
          return {
            px: isInStack ? 0 : 4,
            _web: {
              mb: isInStack ? {
                base: 3,
                lg: 4
              } : 0
            },
            alignItems: "center"
          };
        },
        restaurantDetails_RestAboutSection_Box: {
          px: "6",
          py: {
            base: "6",
            lg: "0"
          }
        },
        restaurantDetails_RestInfo_Outer_ImageBox: {
          position: "relative",
          bg: {
            base: "restaurantDetailsRestInfoBoxBackgroundColor",
            lg: "white"
          }
        },
        restaurantDetails_RestInfo_Mob_StarIcon_Box: {
          m: "auto"
        },
        restaurantDetails_RestInfo_Box: {
          width: "100%",
          alignItems: {
            base: "center",
            lg: "flex-start"
          },
          position: "relative"
        },
        restaurantDetails_RestInfo__Box: {
          width: "100%",
          alignItems: {
            base: "center",
            lg: "flex-start"
          },
          position: "relative"
        },
        restaurantDetails_RestInfo_PhoneNum_Box: {
          mb: {
            base: 4,
            lg: 0
          },
          flexDirection: "row",
          justifyContent: {
            base: "space-evenly",
            lg: "flex-start"
          },
          alignItems: {
            base: "center"
          }
        },
        restaurantDetails_RestInfo_PhoneNum_InnerBox: {
          alignItems: "center",
          flexDirection: "row"
        },
        restaurantDetails_RestTime_Box: {
          px: "4",
          py: {
            base: "4",
            lg: "0"
          }
        },
        restaurantDetails_RestTime_RestClosed_Box: {
          my: 5
        },
        restaurantDetails_RestInfo_ImageBox: {
          backgroundColor: "restaurantImageBorderColor",
          borderColor: "restaurantImageBorderColor",
          borderWidth: 6,
          position: "absolute",
          zIndex: 1,
          alignSelf: "center",
          shadow: 11,
          _web: {
            alignSelf: {
              base: "center",
              lg: "left"
            }
          },
          top: {
            base: "-50px",
            lg: "-150px"
          },
          overflow: "hidden"
        },
        restaurantDetails_RestInfo_ImageLgBox: {
          backgroundColor: "restaurantImageBorderColor",
          borderColor: "restaurantImageBorderColor",
          borderWidth: 6,
          shadow: 11,
          mr: 6
        },
        restaurantDetails_CurrentStatusAndWaitlist_Box: {
          py: "5",
          px: {
            base: "4",
            lg: "8"
          },
          backgroundColor: {
            base: "white",
            lg: "#F4F4F4"
          },
          borderRadius: "12"
        },
        restaurantDetails_CurrentStatus_Box: {
          pt: {
            base: "5",
            lg: "0"
          },
          px: {
            base: "4",
            lg: "0"
          },
          backgroundColor: "white"
        },
        restaurantDetails_Waitlist_Box: {
          pt: {
            base: 7,
            lg: 9
          },
          pb: {
            base: 8,
            lg: 10
          },
          bg: {
            base: "#ffffff",
            lg: "none"
          }
        },
        restaurantDetails_WaitlistAlready_Box: {
          pt: {
            base: 7,
            lg: 9
          },
          mb: {
            base: 8,
            lg: 10
          },
          bg: {
            base: "#ffffff",
            lg: "none"
          }
        },
        restaurantDetails_RestTimings_Divider: {
          marginBottom: 4
        },
        restDetails_TextMapper_Container: {
          py: 16,
          px: {
            base: "60",
            lg: "116"
          },
          bg: "#ffffff"
        },
        //Location search
        tabLocationsTopWidth: 0,
        locationSearchActiveTab: function locationSearchActiveTab(_ref46) {
          var isActive = _ref46.isActive;
          return {
            height: "4px",
            bg: isActive ? "locationSearchActiveTab" : "transparent",
            w: "100%",
            borderTopRadius: "8px"
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref47) {
          var radiusValue = _ref47.radiusValue,
              topRadiusValue = _ref47.topRadiusValue,
              bottomRadiusValue = _ref47.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        homeScreenAlertHeadingWrapper: function homeScreenAlertHeadingWrapper(_ref48) {
          var isSmallScreen = _ref48.isSmallScreen;
          return {
            height: isSmallScreen ? 6 : 7,
            mr: 1
          };
        },
        menu_detail_divider: {
          mb: 5
        },
        boxBorderRadius: {
          borderRadius: 0
        },
        desktopBreadcrumbCaret: function desktopBreadcrumbCaret() {
          return {
            height: 2.5,
            width: 1,
            ml: 2.5,
            mr: 3,
            mb: 1,
            alignItems: "center"
          };
        },
        countLabelContainer: function countLabelContainer(_ref49) {
          var isIOS = _ref49.isIOS;
          return {
            _text: {
              color: "white",
              fontSize: 12,
              _android: {
                pb: 0.5
              }
            }
          };
        },
        categoryBox: {
          mb: {
            md: 8,
            base: 3
          }
        },
        mobileGiftCardBrandLogo: {
          height: 40,
          width: 57
        }
      }
    },
    View: {
      variants: {
        confirmationCardLayout: function confirmationCardLayout() {
          return {
            borderRadius: 0
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref50) {
          var radiusValue = _ref50.radiusValue,
              topRadiusValue = _ref50.topRadiusValue,
              bottomRadiusValue = _ref50.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        }
      }
    },
    Alert: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref51) {
          var radiusValue = _ref51.radiusValue,
              topRadiusValue = _ref51.topRadiusValue,
              bottomRadiusValue = _ref51.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        }
      }
    },
    Menu: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref52) {
          var radiusValue = _ref52.radiusValue,
              topRadiusValue = _ref52.topRadiusValue,
              bottomRadiusValue = _ref52.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        }
      }
    },
    ActionsheetContent: {
      variants: {
        topRounded: {}
      }
    },
    PopoverContent: {
      variants: {
        popoverRadius: function popoverRadius(_ref53) {
          var radiusValue = _ref53.radiusValue;
          return {
            borderRadius: radiusValue
          };
        }
      }
    },
    Switch: {
      baseStyle: {
        thumbColor: "#FFFFFF",
        onTrackColor: "primary.100"
      }
    },
    Select: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref54) {
          var radiusValue = _ref54.radiusValue,
              topRadiusValue = _ref54.topRadiusValue,
              bottomRadiusValue = _ref54.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        }
      }
    }
  },
  fontConfig: {
    Barlow: {
      100: {
        normal: "Barlow-Light",
        italic: "Barlow-LightItalic"
      },
      200: {
        normal: "Barlow-Light",
        italic: "Barlow-LightItalic"
      },
      300: {
        normal: "Barlow-Regular",
        italic: "Barlow-Regular"
      },
      400: {
        normal: "Barlow-Medium",
        italic: "Barlow-MediumItalic"
      },
      500: {
        normal: "Barlow-Bold",
        italic: "Barlow-BoldItalic"
      },
      600: {
        normal: "Barlow-SemiBold",
        italic: "Barlow-SemiBoldItalic"
      },
      700: {
        normal: "Barlow-ExtraBold",
        italic: "Barlow-ExtraBoldItalic"
      }
    },
    S52: {
      100: {
        normal: "S52-Regular",
        italic: "S52-Regular"
      },
      200: {
        normal: "S52-Regular",
        italic: "S52-Regular"
      },
      300: {
        normal: "S52-Regular",
        italic: "S52-Regular"
      },
      400: {
        normal: "S52-Regular",
        italic: "S52-Regular"
      },
      500: {
        normal: "S52-Regular",
        italic: "S52-Regular"
      },
      600: {
        normal: "S52-Regular",
        italic: "S52-Regular"
      },
      700: {
        normal: "S52-Regular",
        italic: "S52-Regular"
      },
      800: {
        normal: "S52-Bold",
        italic: "S52-Bold"
      }
    }
  },
  fonts: {
    heading: "Barlow",
    body: "Barlow",
    headingSecondary: "Barlow",
    youMightLikeText: "Barlow-Bold",
    s52: "S52"
  },
  config: {
    // Changing initialColorMode to 'dark'
    initialColorMode: "light"
  }
}; // extend the theme

export var theme = extendTheme(_objectSpread(_objectSpread({}, baseTheme), config));